import { get, post, gets } from './http';
import axios from 'axios';
import baseURL from '@/request/url.js';


//项目定制化模块报表
// 经营情况表-湘玉贵金属
export const apiOperatingRptXiangYu = p => post("OperatingRpt_xiangyu", p); // 列表
export const apiOperatingRptXiangYuPull = p => get("OperatingRptPull_xiangyu", p); // 下拉
export const apiOperatingRptXiangYuExport = (p) => {
  return axios({
    url: baseURL + 'OperatingRpt_xiangyu',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};

export const apiTest = p => get('field_all', p); //测试

export const openApi = p => get('img_parameter_open_api', p); // 开放接口 获取登录背景图
export const repeatLogin = p => get('verify_is_login', p); // 检测重复登录
export const quitLogin = p => get('quit_login', p); // 检测重复登录


//公共接口
export const apiGetCutAccount = p => get('getCutAccount', p); //获取客户存欠
export const apiGetStyleSelectCounter = p => get('getStyleSelectCounter', p); //获取选择柜台的产品
export const apiGetModuleParamSetData = p => get('getModuleParamSetData', p); //获取模块内参数设置
export const apiGetCustParamSetData = p => get('getCustParamSetData', p); //获取客户金额参数设置
export const apiUpModuleParamSetData = p => post('upModuleParamSetData', p); //修改模块内参数设置
export const apiCustPullSearch = p => get('custPullSearch', p); // 客户远程搜索

// 系统设置
export const apiSystem = p => get('parameter_details', p); //参数详情
export const apiFormatOrderAmt = p => get('formatOrderAmt', p); //根据系统参数格式化单据金额
export const apiSystemSave = p => post('update_parameter', p); //参数保存
export const apiSystemPull = p => get('parameter_pull', p); //参数下拉
export const apiSystemLog = p => get('log_list', p); //日志列表
export const apiSystemLogPull = p => get('log_pull', p); //日志下拉
export const apiSystemModule = p => get('recentuse', p); //常用模块
export const apiSystemModuleOften = p => get('recentuse_user_list', p); //用户常用模块
export const apiOnline = p => get('online_number', p); //在线人数
export const apiIndexAll = p => get('index_api_all', p); //首页全部信息
export const apiGetBarcodePrintLink = p => post('printLabel_barcodesin', p); //获取打印链接-条码入库
export const apiGetBarcodePrintLinkExport = (p) => {
  return axios({
    url: baseURL + 'printLabel_barcodesin',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
export const apiGetSepwgtPrintLink = p => post('printLabel_sepwgt', p); //获取打印链接-分称
export const apiGetSepwgtPrintLinkExport = (p) => {
  return axios({
    url: baseURL + 'printLabel_sepwgt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
export const apiGetGoldSliveInPrintLink = p => post('printLabel_goldsilverin', p); //获取打印链接-金包银入库
export const apiGetGoldSliveInPrintLinkExport = (p) => {
  return axios({
    url: baseURL + 'printLabel_goldsilverin',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
//公告
export const apiNotice = p => get('notice_list_new_get', p); //公告列表
export const apiNoticeAdd = p => post('notice_add', p); //添加
export const apiNoticeIndex = p => get('notice_index', p); //首页公告
export const apiNoticeNum = p => get('notice_index_read', p); //公告统计
export const apiNoticeDetail = p => get('notice_details_all', p); //公告详情
export const apiNoticeDel = p => get('delete_notice', p); //删除公告
export const apiNoticePull = p => get('notice_pull', p); //下拉
export const apiNoticeOK = p => get('notice_index_ok', p); //公告已读

//公告图片
export const apiNoticeImg_list = p => get('img_all_list', p); //列表
export const apiNoticeImg_add = p => post('img_parameter_add', p); // 添加
export const apiNoticeImg_edit = p => post('img_parameter_update', p); // 修改
export const apiNoticeImg_detail = p => get('img_parameter_details', p); // 详情
export const apiNoticeImg_del = p => get('img_parameter_delete', p); // 删除
export const apiNoticeImg_pull = p => get('img_parameter_pull', p); // 下拉
export const apiNoticeImg_img = p => get('img_parameter_open_api', p); // 登录页面请求的背景图片

// 登录
export const apiLogin = p => post('login', p); //登陆
export const apiAuthorizedLogin = p => get('login_lv', p); //管理员授权登录
export const apiLogin_QR = p => get('wx_sm_login', p); // 二维码登陆
export const apiLogin_scanQR = p => get('get_wx_qr_login', p); // 获取扫码状态(登录)
export const apiLogin_bd_scanQR = p => get('get_wx_bd_login', p); // 获取扫码状态(绑定)
export const apiLogin_localToken = p => get('push_local_token', p); // 刷新在线时间

export const apiGetinfo = p => get('user_info', p); //获取用户信息
export const apiUpload = p => post('upload_img', p); //上传图片
export const apiUploadOss_img = p => post('uploadOss_img', p); //上传图片
export const apimodifyPwd = p => post('update_password', p); //修改密码
export const apipullSearch = p => get('project_all_pull', p); //下拉搜索
export const delOss_imgBill = p => post('delOss_imgBill', p); //删除图片
export const uploadOss_imgBill = p => post('uploadOss_imgBill', p); //上传图片

// 类别目录
export const apisetList = p => get('get_categor', p); //类别列表
export const apisetDetail = p => get('categor_details', p); //类别详情
export const apiaddSet = p => post('add_categor', p); //添加类别
export const apimodifySet = p => post('update_categor', p); //修改类别
export const apidelSet = p => get('delete_categor', p); //删除类别
// 单据类型
export const apibilltypeList = p => get('billtype_list', p); //列表
export const apiaddBillType = p => post('add_billType', p); //添加
export const apiupdateBilltype = p => post('update_billtype', p); //修改
export const apideleteBilltype = p => get('delete_billtype', p); //删除
export const apibilltypePull = p => get('billtype_pull', p); //下拉搜索


// 柜台状态管理
export const apiGetCounterStatusList = p => post("Index_CounterLock", p); // 获取柜台状态管理列表
export const apiUpdateCounterStatus = p => post("UpLock_CounterLock", p); // 改变柜台状态
export const apiUpdateCounterData = p => post("update_CounterLock", p); // 编辑柜台数据
export const apiAddCounterData = p => post("add_CounterLock", p); // 新增柜台数据
export const apiDeleteCounterData = p => get("delete_CounterLock", p); // 删除柜台数据
export const apiCounterManagePull = p => get("pull_CounterLock", p); // 柜台管理下拉

// 定价类型管理
export const apiGetPricingTypeStatusList = p => post("index_PricingTypeManage", p); // 获取定价类型管理列表
export const apiUpdatePricingTypeStatus = p => post("upStatus_PricingTypeManage", p); // 改变定价类型状态
export const apiUpdatePricingTypeData = p => post("update_PricingTypeManage", p); // 编辑定价类型数据
export const apiAddPricingTypeData = p => post("add_PricingTypeManage", p); // 新增定价类型数据
export const apiDeletePricingTypeData = p => get("delete_PricingTypeManage", p); // 删除定价类型数据
export const apiPricingTypeManagePull = p => get("pull_PricingTypeManage", p); // 定价类型管理下拉

// 结算方式管理
export const apiGetBillModeStatusList = p => post("index_BillModeManage", p); // 获取结算方式管理列表
export const apiUpdateBillModeStatus = p => post("upStatus_BillModeManage", p); // 改变结算方式状态
export const apiUpdateBillModeData = p => post("update_BillModeManage", p); // 编辑结算方式数据
export const apiAddBillModeData = p => post("add_BillModeManage", p); // 新增结算方式数据
export const apiDeleteBillModeData = p => get("delete_BillModeManage", p); // 删除结算方式数据
export const apiBillModeManagePull = p => get("pull_BillModeManage", p); // 结算方式管理下拉

// 金料定价方案
export const apiGetMetalPricingPlanStatusList = p => post("index_MetalPricingPlan", p); // 获取金料定价方案列表
export const apiUpdateMetalPricingPlanStatus = p => post("upStatus_MetalPricingPlan", p); // 改变金料定价方案状态
export const apiUpdateMetalPricingPlanData = p => post("update_MetalPricingPlan", p); // 编辑金料定价方案数据
export const apiAddMetalPricingPlanData = p => post("add_MetalPricingPlan", p); // 新增金料定价方案数据
export const apiDeleteMetalPricingPlanData = p => get("delete_MetalPricingPlan", p); // 删除金料定价方案数据
export const apiMetalPricingPlanPull = p => get("pull_MetalPricingPlan", p); // 金料定价方案管理下拉
export const apiCheckMetalPricingPlanData = p => get("check_MetalPricingPlan", p); // 审核金料定价方案管理
export const apiGetMetalPricingPlanDtlDate = p => post("getDtl_MetalPricingPlan", p); //获取金料定价方案明细数据
export const apiUpdateDtlMetalPricingPlanData = p => post("upDtl_MetalPricingPlan", p); //修改金料定价方案明细数据
export const apiAddDtlMetalPricingPlanData = p => post("addDtl_MetalPricingPlan", p); //新增金料定价方案明细数据
export const apiDeleteDtlMetalPricingPlanData = p => get("delDtl_MetalPricingPlan", p); //删除金料定价方案明细数据
export const apiCustMetalPricingPlanData = p => get("getCustPlan_MetalPricingPlan", p); //获取客户金料定价方案数据

// 部门管理
export const apiGetDeptStatusList = p => post("index_DeptManage", p); // 获取部门管理列表
export const apiUpdateDeptStatus = p => post("upStatus_DeptManage", p); // 改变部门状态
export const apiUpdateDeptData = p => post("update_DeptManage", p); // 编辑部门数据
export const apiAddDeptData = p => post("add_DeptManage", p); // 新增部门数据
export const apiDeleteDeptData = p => get("delete_DeptManage", p); // 删除部门数据
export const apiDeptManagePull = p => get("pull_DeptManage", p); // 部门管理下拉

// 费用项目管理
export const apiGetExpenseProjectStatusList = p => post("index_ExpenseProjectManage", p); // 获取部门管理列表
export const apiUpdateExpenseProjectStatus = p => post("upStatus_ExpenseProjectManage", p); // 改变部门状态
export const apiUpdateExpenseProjectData = p => post("update_ExpenseProjectManage", p); // 编辑部门数据
export const apiAddExpenseProjectData = p => post("add_ExpenseProjectManage", p); // 新增部门数据
export const apiDeleteExpenseProjectData = p => get("delete_ExpenseProjectManage", p); // 删除部门数据
export const apiExpenseProjectManagePull = p => get("pull_ExpenseProjectManage", p); // 部门管理下拉

// 账户管理
export const apiGetBankStatusList = p => post("index_BankManage", p); // 获取账户管理列表
export const apiUpdateBankStatus = p => post("upStatus_BankManage", p); // 改变账户状态
export const apiUpdateBankData = p => post("update_BankManage", p); // 编辑账户数据
export const apiAddBankData = p => post("add_BankManage", p); // 新增账户数据
export const apiDeleteBankData = p => get("delete_BankManage", p); // 删除账户数据
export const apiBankManagePull = p => get("pull_BankManage", p); // 账户管理下拉
export const exportTemplate_BankManage = (p) => {
  return axios({
    url: baseURL + 'exportTemplate_BankManage',
    method: 'get',
    params: p,
    responseType: 'arraybuffer'
  });
};


//类别设定
export const apisetListSon = p => get('get_category_dtl', p); //子类列表
export const apisetDetailSon = p => get('category_dtl_details', p); //子类详情
export const apiaddSetSon = p => post('add_category_dtl', p); //添加子类
export const apiaddSetSonstatus = p => post('upStatus_categoryDtl', p); //状态
export const apimodifySetSon = p => post('update_category_dtl', p); //修改子类
export const apidelSetSon = p => get('delete_category_dtl', p); //删除子类

// 表格列设置
export const apiGetMainTypeList = p => get('list_TableColumn', p); //获取列表
export const apiGetListCorrespondingData = p => get('column_TableColumn', p); //获取表格字段设置信息
export const apiGetListCorrespondingSetData = p => get('setColumn_TableColumn', p); //获取表格字段设置信息
export const apiUpdateListCorrespondingData = p => post('Update_TableColumn', p); //模块内更新表格字段设置信息
export const apiSetListCorrespondingData = p => post('saveSet_TableColumn', p); //更新表格字段设置信息
export const apiGetListCorrespondingReportData = p => post('updateHeadSort_ReportColumn', p); //报表

// 名词翻译管理
export const apiListTranslationNouns = p => post('index_TranslationNouns', p); //获取列表
export const apiDeleteTranslationNouns = p => get('delete_TranslationNouns', p); //删除
export const apiAddTranslationNouns = p => post('add_TranslationNouns', p); //新增
export const apiUpdateTranslationNouns = p => post('update_TranslationNouns', p); //修改

// 员工管理
export const apisetListPeople = p => get('get_staff', p); //员工列表
export const apisetDetailPeople = p => get('staff_details', p); //员工详情
export const apiaddSetPeople = p => post('add_staff', p); //添加员工
export const apimodifySetPeople = p => post('update_staff', p); //修改员工
export const apidelSetPeople = p => get('delete_staff', p); //删除员工
export const apialterStatusPeople = p => get('update_enable_staff', p); // 修改启用
export const apialterStatusAllowLogin = p => get('upAllowLogin_staff', p); //  使用系统 
export const apiSSetPeople = p => get('get_category_del_pull', p); //员工下拉列表
export const apiAllSelectSetPeople = p => get('pull_staff', p); //员工所有下拉列表
export const apistaff_wx = p => get('staff_wx', p); //员工查看绑定
export const apistaff_wx_delete = p => get('staff_wx_delete', p); //员工解除绑定
export const apiSetPeoplestorepull_staff = p => get('storepull_staff', p); //获取部门柜台下拉
export const apiSetPeoplestorebindDevice = p => get('bindDevice_password', p); //绑定设备
//客户管理
export const apisetListVip = p => get('customer_list', p); //客户列表
export const apisetDetailVip = p => get('customer_details', p); //客户详情
export const apiaddSetVip = p => post('add_customer', p); //添加客户
export const apialterStatusSetVip = p => get('update_enable_cust', p); // 修改启用
export const apimodifySetVip = p => post('update_customer', p); //修改客户
export const apidelSetVip = p => get('dalete_customer', p); //删除客户
export const apiSSetVipSale = p => get('pull_user_salesman', p); //下拉列表
export const apiAllSelectSetVip = p => get('pull_customer', p); //所有下拉列表
export const apiCustPull = p => get('get_wage_type_pull', p); //选择客户和产品带出工费
export const getImportCust = p => post('get_import_cust', p); //导入客户
export const apiSetVipstorepull_staff = p => get('storepull_customer', p); //获取部门柜台下拉
export const apiSetVipstoredel = p => post('delOss_img', p); //删除图片
export const apiCreateMemberCustomer = p => get('createMember_customer', p); //删除图片

//客户工费
export const apiWorkCust = p => get('get_wage', p); //查询
export const apiWorkCustMody = p => post('add_or_update_wage', p); //添加修改
export const apiWorkCustPull = p => get('wage_pull', p); //下拉
//工费类型
export const apiWorkFee = p => get('get_wage_type', p); //查询
export const apiWorkFeeMody = p => post('add_or_update_wage_type', p); //添加修改
export const apiWorkFeePull = p => get('wage_type_pull', p); //下拉
export const apiWorkFee_add = p => get('wage_type_list_dtl', p); // 新增带出
export const apiWorkFee_copy = p => get('copy_wage_type', p); // 复制
//产品工费类型
export const apiWorkFeeProduct = p => get('get_style_wage_type', p); //查询
export const apiWorkFeeProductMody = p => post('add_or_update_style_wage_type', p); //添加修改
export const apiWorkFeeProductPull = p => get('style_wage_type_pull', p); //下拉
// 数据字典
export const apiDictionaryList = p => get('word_list', p); //字典列表
export const apiDictionaryDetail = p => get('word_details', p); //字典详情
export const apiaddDictionary = p => post('add_word', p); //添加字典
export const apimodifyDictionary = p => post('update_word', p); //修改字典
export const apidelDictionary = p => get('word_delete', p); //删除字典
export const apiPullDictionary = p => get('word_pull', p); //下拉框
export const apiGetSeq = p => get('get_sort_seq', p); // 获取排序
// 权限设置
export const apiPermission = p => get('staff_popedom', p); //员工权限
export const apiPermissionLogin = p => get('popedom_user_lv_login', p); //授权他人登录权限
export const apiPermissionList = p => get('popedom_line', p); //权限列
export const apimodifyPermission = p => post('update_popedom', p); //修改权限
export const apimodifyAllPermission = p => post('updateAll_popedom', p); //修改权限
export const apiCurrentPermisson = p => get('user_popedom', p); //当前用户对应页面权限展示
export const apiPermissonDetail = p => get('popedom_details', p); //用户权限详情
export const apiPermissonDetailtable = p => get('popedom_rpt_get', p); //用户报表权限详情
export const apimodifyPermissionTable = p => post('popedom_rpt_update', p); //修改报表权限
export const apiPermissonAll = p => get('user_popedom_all', p); //所有权限列表
export const apiPermissonSlider = p => get('popedom_use', p); //导航栏列表
export const apiPermissonCopy = p => get('pull_user', p); //复制权限下拉
export const apiPermissonCopyIt = p => post('popedom_user_cope', p); //复制权限
export const apiPermissonLevel = p => get('popedom_user_level', p); //权限等级
export const apiPermissonSearch = p => get('popedom_pull', p); //权限搜索下拉
export const apiPermissonAllow = p => get('popedom_allow_cost', p); //查看成本
export const apiPermissonAllowLowerprc = p => get('popedom_allow_lowerprc', p); //允许低价开单

// 配件
export const apiPjList = p => get('style_pj_list', p); //配件列表
export const apiPjDetail = p => get('style_pj_details', p); //配件详情
export const apiaddPj = p => post('add_style_pj', p); //添加配件
export const apimodifyPj = p => post('update_style_pj', p); //修改配件
export const apidelPj = p => get('dalete_style_pj', p); //删除配件
export const apiPjcheck = p => get('style_pj_check', p); //配件审核按钮
export const apiPjImg = p => post('style_img', p); //上传图片
export const apiImportExcelPj = p => post('style_pj_import', p); //配件导入
export const apiAllSelectPj = p => get('pull_style_pj_all', p); //所有下拉列表
// 金料
export const apiGlodList = p => get('style_gold_list', p); //金料列表
export const apiGlodDetail = p => get('style_gold_details', p); //金料详情
export const apiaddGlod = p => post('add_style_gold', p); //添加金料
export const apimodifyGlod = p => post('update_style_gold', p); //修改金料
export const apidelGlod = p => get('dalete_style_gold', p); //删除金料
export const apiGlodcheck = p => get('style_gold_check', p); //金料审核按钮
export const apiExportExcel = p => get('style_gold_export', p); //金料导出Excel
export const apiImportExcel = p => post('style_gold_import', p); //金料导入
export const apiAllSelectGlod = p => get('pull_style_gold', p); //所有下拉列表
// 产品
export const apiFirstPro = p => get('stylesec_first', p); //第一个产品
export const apiNextPro = p => get('stylesec_next', p); //下一个产品
export const apiPrevPro = p => get('stylesec_prev', p); //上一个产品
export const apiLastPro = p => get('stylesec_last', p); //最后一个产品
export const apiSearchPro = p => get('stylesec_list', p); //查询产品
export const apiaddPro = p => post('add_stylesec', p); //添加产品
export const apiModifyPro = p => post('update_stylesec', p); //修改产品
export const apiDelPro = p => get('delete_stylesec', p); //删除产品
export const apiExportPro = p => get('stylesec_export', p); //产品及子表导出
export const apiExportProTem = p => get('stylesec_template_export', p); //产品及字表模板导出
export const apiImportPro = p => post('stylesec_import', p); //产品及子表导入
export const apiAllSelect = p => get('all_pull', p); //所有下拉框
export const apiProS = p => post('screen_stylesec', p); //查询筛选
export const apicheckPro = p => get('stylesec_check', p); //审核
export const apiProGoldOut = p => get('gold_ratio', p); //金成色带出转换比例
// 素金
export const apiFirstProSj = p => get('only_stylesec_first', p); //第一个产品
export const apiNextProSj = p => get('only_stylesec_next', p); //下一个产品
export const apiPrevProSj = p => get('only_stylesec_prev', p); //上一个产品
export const apiLastProSj = p => get('only_stylesec_last', p); //最后一个产品
export const apiSearchProSj = p => get('only_stylesec_list', p); //查询产品
export const apiaddProSj = p => post('only_add_stylesec', p); //添加产品
export const apiModifyProSj = p => post('only_update_stylesec', p); //修改产品
export const apiDelProSj = p => get('only_delete_stylesec', p); //删除产品
export const apiProSSj = p => post('screen_stylesecsj', p); //查询筛选
// 金价
export const apiFirstPrice = p => get('gold_price_first', p); //第一个
export const apiNextPrice = p => get('gold_price_next', p); //下一个
export const apiPrevPrice = p => get('gold_price_prev', p); //上一个
export const apiLastPricer = p => get('gold_price_last', p); //最后一个
export const apiSearchPrice = p => get('gold_price_list', p); //查询
export const apiaddPrice = p => post('add_gold_price', p); //添加
export const apiModifyPrice = p => post('update_gold_price', p); //修改
export const apiDelPrice = p => get('dalete_gold_price', p); //删除
export const apiImportPrice = p => post('gold_price_import', p); //导入
export const apiExportPrice = p => get('gold_price_export', p); //导出
export const apiExportPriceTem = p => get('gold_price_template_export', p); //模板导出
export const apicheckPrice = p => get('gold_price_check', p); //审核
export const apichoosePrice = p => post('screen_gold_price', p); //筛选
export const apiAllSelectPrice = p => get('pull_gold_price', p); //所有下拉列表
export const apiPriceAllCheck = p => get('all_gold_price_check', p); //批量审核
export const apiAddList = p => get('new_add_pull', p); // 新增放入数据
// 金价管理

export const apiGoldprice = p => get('index_goldprice', p); //列表
export const apiGoldpricePull = p => get('pull_goldprice', p); //下拉
export const apiGoldpriceAdd = p => post('add_goldprice', p); //新增
export const apiGoldpriceEdit = p => post('update_goldprice', p); //修改
export const apiGoldpriceDels = p => get('dels_goldprice', p); //删除
export const apiGoldpriceCheck = p => get('checks_goldprice', p); //审核

// 石头
export const apiStoneList = p => get('style_stone_list', p); //石头列表
export const apiStoneDetail = p => get('style_stone_details', p); //石头详情
export const apiaddStone = p => post('add_style_stone', p); //添加石头
export const apimodifyStone = p => post('update_style_stone', p); //修改石头
export const apidelStone = p => get('dalete_style_stone', p); //删除石头
export const apiExportStone = p => get('style_stone_export', p); //石头导出
export const apiExportStoneTem = p => get('style_stone_template_export', p); //石头模板导出
export const apiImportStone = p => post('style_stone_import', p); //石头导入
export const apiAllSelectStone = p => get('pull_style_stone', p); //所有下拉列表
export const apiStonecheck = p => get('style_stone_check', p); //审核按钮
//品类结价折转设定
export const apiClassList = p => get('gold_trans_list', p); //列表
export const apiClassDetail = p => get('trans_details', p); //详情
export const apiaddClass = p => post('add_trans', p); //添加
export const apimodifyClass = p => post('update_trans', p); //修改
export const apidelClass = p => get('dalete_trans', p); //删除
export const apipullClass = p => get('trans_pull', p); //下拉
export const apiBiaoQian = p => get('sub_dy_biaoqian', p); //下拉
// 订购

export const apiListPull = p => get('get_style_wage', p); //第一个订购
export const apiListPullTwo = p => get('get_wage_type_pull_two', p); //第一个订购
export const apiFirstOrder = p => get('subscribe_first', p); //第一个订购
export const apiNextOrder = p => get('subscribe_next', p); //下一个订购
export const apiPrevOrder = p => get('subscribe_prev', p); //上一个订购
export const apiLastOrder = p => get('subscribe_last', p); //最后一个订购
export const apiSearchOrder = p => get('subscribe_list', p); //查询订购
export const apiaddOrder = p => post('add_subscribe', p); //添加订购
export const apiModifyOrder = p => post('update_subscribe', p); //修改订购
export const apiDelOrder = p => get('dalete_subscribe', p); //删除订购
export const apiExportOrder = p => get('subscribe_export', p); //订购或订购明细导出
export const apiExportOrderTem = p => get('subscribe_template_export', p); //订购或订购明细模板导出
export const apiAllSelectOrder = p => get('pull_subscribe', p); //所有下拉框
export const apicheckOrder = p => get('subscribe_check', p); //审核
export const apichooseOrder = p => post('screen_subscribe', p); //筛选
export const apichooseCust = p => get('cust_salesman', p); //下拉客户
export const apiOrderOut = p => get('pull_wage', p); //下拉带出数据
export const apiOrderPrint = p => get('subscribe_report', p); //打印
export const apiOrderAllCheck = p => get('all_subscribe_check', p); //批量审核
export const daleteSubscribes = p => get('dalete_subscribes', p); //批量删除
export const subscribe_tag = p => get('subscribe_tag', p); //标签打印


// 定价
export const apiFirstSetPrice = p => get('setprice_first', p); //第一个
export const apiNextSetPrice = p => get('setprice_next', p); //下一个
export const apiPrevSetPrice = p => get('setprice_prev', p); //上一个
export const apiLastSetPrice = p => get('setprice_last', p); //最后一个
export const apiSearchSetPrice = p => get('setprice_list', p); //查询
export const apiaddSetPrice = p => post('add_setprice', p); //添加
export const apiModifySetPrice = p => post('update_setprice', p); //修改
export const apiDelSetPrice = p => get('dalete_setprice', p); //删除
export const apiAllSelectSetPrice = p => get('pull_setprice', p); //所有下拉框
export const apicheckSetPrice = p => get('setprice_check', p); //审核
export const apichooseSetPrice = p => post('screen_setprice', p); //筛选
export const apiCancelSetPrice = p => get('setprice_cancel', p); //取消
// 订单管理
export const apiFirstOrderManage = p => get('order_first', p); //第一个
export const apiNextOrderManage = p => get('order_next', p); //下一个
export const apiPrevOrderManage = p => get('order_prev', p); //上一个
export const apiLastOrderManage = p => get('order_last', p); //最后一个
export const apiSearchOrderManage = p => get('order_list', p); //查询
export const apiaddOrderManage = p => post('add_order', p); //添加
export const apiModifyOrderManage = p => post('update_order', p); //修改
export const apiDelOrderManage = p => get('dalete_order', p); //删除
export const apiAllSelectOrderManage = p => get('pull_order', p); //所有下拉框
export const apicheckOrderManage = p => get('order_check', p); //审核
export const apichooseOrderManage = p => post('screen_order', p); //筛选
export const apiPrintOrderManage = p => get('order_report', p); //取消
export const apiOutOrderManage = p => get('style_qty', p); //明细带出
export const apiOrderManageAllCheck = p => get('all_order_check', p); //批量审核
export const subscribeGetList = p => get('subscribe_get_list', p); //批量审核
// 入库
export const apiaddInbound = p => post('add_insj', p); //添加和修改入库
export const apicalculateInbound = p => post('insj_calculate', p); //整计
export const apidelInbound = p => get('dalete_insj', p); //删除入库
export const apichooseInbound = p => post('screen_insj', p); //筛选
export const apiaccountInbound = p => get('cust_mtrstock', p); //账户信息
export const apisearchInbound = p => get('insj_list', p); //查询
export const apifirstInbound = p => get('insj_first', p); //第一个
export const apinextInbound = p => get('insj_next', p); //下一个
export const apiprevInbound = p => get('insj_prev', p); //上一个
export const apilastInbound = p => get('insj_last', p); //最后一个
export const apipullInbound = p => get('pull_insj', p); //下拉及筛选条件
export const apitotalInbound = p => post('insj_combined', p); //合计
export const apicheckInbound = p => get('insj_check', p); //审核l
export const apiexportInbound = p => get('insj_export', p); //入库导出
export const apiexportTemInbound = p => get('insj_template_export', p); //入库模板导出
export const apiPrintInbound = p => get('insj_report', p); //打印
export const apiOutcustInbound = p => get('insj_subsctibe_cust', p); //选择客户带出定价
export const apiokInbound = p => post('insj_setprice_ok', p); //定价OK
export const apiInboundAllCheck = p => get('all_insj_check', p); //批量审核
export const apiPrintInboundprintLabel = p => get('printLabel_insj', p); //打印

// 出库
export const apicustOutbound = p => get('subsctibe_cust', p); //选择客户带出订购
export const apiokOutbound = p => post('subsctibe_ok', p); //选择订购单号列出出货明细
export const apiokPriceOutbound = p => post('salesj_setprice_ok', p); //定价OK按钮
export const apiaddOutbound = p => post('add_salesj', p); //添加和修改出库
export const apicalculateOutbound = p => post('salesj_calculate', p); //整计
export const apidelOutbound = p => get('dalete_salesj', p); //删除出库
export const apichooseOutbound = p => post('screen_salesj', p); //筛选
export const apisearchOutbound = p => get('salesj_list', p); //查询
export const apifirstOutbound = p => get('salesj_first', p); //第一个
export const apinextOutbound = p => get('salesj_next', p); //下一个
export const apiprevOutbound = p => get('salesj_prev', p); //上一个
export const apilastOutbound = p => get('salesj_last', p); //最后一个
export const apipullOutbound = p => get('pull_salesj', p); //下拉及筛选条件
export const apiguitaipullOutbound = p => get('pull_sales_style', p); //chuku柜台下拉
export const apiguitaiinOutbound = p => get('pull_style', p); //ruku柜台下拉
export const apitotalOutbound = p => post('salesj_combined', p); //合计
export const apicheckOutbound = p => get('salesj_check', p); //审核
export const apiexportOutbound = p => get('salesj_export', p); //出库导出
export const apiexportTemOutbound = p => get('salesj_template_export', p); //出库模板导出
export const apiPrintOutbound = p => get('salesj_report', p); //打印
export const apiPrintOutboundprintLabel = p => get('printLabel_salesj', p); //打印
export const apiOutboundAllCheck = p => get('all_salesj_check', p); //全部审核
export const salesjBring = p => get('salesj_bring', p); //出库调用
export const salesjBringStyle = p => get('salesj_bring_style', p); //出库调用

// 标签打印
export const apiLabelPrintGetPull = p => get('pull_labelprint', p); //下拉
export const apiLabelPrintGetData = p => post('search_labelprint', p); //单据搜索
export const apiLabelPrintAddData = p => post('add_labelprint', p); //新增
export const apiLabelPrintUpdateData = p => post('update_labelprint', p); //修改
export const apiLabelPrintDelData = p => post('del_labelprint', p); //删除
export const apiLabelPrintGetBarcodeData = p => post('getBarcodes_labelprint', p); //删除
export const apiLabelPrintPrintBarcodes = p => post('printBarcodes_labelprint', p);
export const apiLabelPrintPrintStyles = p => post('printStyles_labelprint', p);


// 销购管理
export const apiSalesProcureGetPull = p => get('pull_salesprocure', p); //下拉
export const apiSalesProcureGetData = p => post('search_salesprocure', p); //单据搜索
export const apiSalesProcureAddData = p => post('add_salesprocure', p); //新增
export const apiSalesProcureUpdateData = p => post('update_salesprocure', p); //修改
export const apiSalesProcureDelData = p => post('del_salesprocure', p); //删除
export const apiSalesProcureDelsData = p => post('dels_salesprocure', p); //批量删除
export const apiSalesProcurecheck = p => post('check_salesprocure', p); //审核
export const apiSalesProcurechecks = p => post('checks_salesprocure', p); //批量审核
export const apiSalesProcurePriceAdMate = p => post('reflex_salesprocure', p); //结价结料
export const apiSalesProcureTempPrint = p => get('report_salesprocure', p); //打印
export const apiSalesProcureGetOrderList = p => post('index_salesprocure', p); //单据列表查询
export const apiTotalDataProcureGetOrderList = p => post('totalData_salesprocure', p); //单据合计数
export const apiSalesProcureGetMetalPricingData = p => post('getMetalPricingData_salesprocure', p); //获取定价单


// 粗料入库管理
export const apiCoarseMetalInGetPull = p => get('pull_coarsemetalin', p); //下拉
export const apiCoarseMetalInGetData = p => post('search_coarsemetalin', p); //单据搜索
export const apiCoarseMetalInAddData = p => post('add_coarsemetalin', p); //新增
export const apiCoarseMetalInUpdateData = p => post('update_coarsemetalin', p); //修改
export const apiCoarseMetalInDelData = p => post('del_coarsemetalin', p); //删除
export const apiCoarseMetalInDelsData = p => post('dels_coarsemetalin', p); //批量删除
export const apiCoarseMetalIncheck = p => post('check_coarsemetalin', p); //审核
export const apiCoarseMetalInchecks = p => post('checks_coarsemetalin', p); //批量审核
export const apiCoarseMetalInPriceAdMate = p => post('reflex_coarsemetalin', p); //结价结料
export const apiCoarseMetalInTempPrint = p => get('report_coarsemetalin', p); //打印
export const apiCoarseMetalInGetOrderList = p => post('index_coarsemetalin', p); //单据列表查询
export const apiCoarseMetalInTotalData = p => post('totalData_coarsemetalin', p); //单据合计数
export const apiCoarseMetalInGetMetalPricingData = p => post('getMetalPricingData_coarsemetalin', p); //获取定价单

// 粗料出库管理
export const apiCoarseMetalOutGetPull = p => get('pull_coarsemetalout', p); //下拉
export const apiCoarseMetalOutGetData = p => post('search_coarsemetalout', p); //单据搜索
export const apiCoarseMetalOutAddData = p => post('add_coarsemetalout', p); //新增
export const apiCoarseMetalOutUpdateData = p => post('update_coarsemetalout', p); //修改
export const apiCoarseMetalOutDelData = p => post('del_coarsemetalout', p); //删除
export const apiCoarseMetalOutDelsData = p => post('dels_coarsemetalout', p); //批量删除
export const apiCoarseMetalOutcheck = p => post('check_coarsemetalout', p); //审核
export const apiCoarseMetalOutchecks = p => post('checks_coarsemetalout', p); //批量审核
export const apiCoarseMetalOutPriceAdMate = p => post('reflex_coarsemetalout', p); //结价结料
export const apiCoarseMetalOutTempPrint = p => get('report_coarsemetalout', p); //打印
export const apiCoarseMetalOutGetOrderList = p => post('index_coarsemetalout', p); //单据列表查询
export const apiCoarseMetalOutTotalData = p => post('totalData_coarsemetalout', p); //单据合计数
export const apiCoarseMetalOutGetMetalPricingData = p => post('getMetalPricingData_coarsemetalout', p); //获取定价单

// 旧料入库管理
export const apiOldMetalInGetPull = p => get('pull_oldmetalin', p); //下拉
export const apiOldMetalInGetData = p => post('search_oldmetalin', p); //单据搜索
export const apiOldMetalInAddData = p => post('add_oldmetalin', p); //新增
export const apiOldMetalInUpdateData = p => post('update_oldmetalin', p); //修改
export const apiOldMetalInDelData = p => post('del_oldmetalin', p); //删除
export const apiOldMetalInDelsData = p => post('dels_oldmetalin', p); //批量删除
export const apiOldMetalIncheck = p => post('check_oldmetalin', p); //审核
export const apiOldMetalInchecks = p => post('checks_oldmetalin', p); //批量审核
export const apiOldMetalInPriceAdMate = p => post('reflex_oldmetalin', p); //结价结料
export const apiOldMetalInTempPrint = p => get('report_oldmetalin', p); //打印
export const apiOldMetalInGetOrderList = p => post('index_oldmetalin', p); //单据列表查询
export const apiOldMetalInTotalData = p => post('totalData_oldmetalin', p); //单据合计数

// 提纯发出管理
export const apiPurifyOutGetPull = p => get('pull_purifyout', p); //下拉
export const apiPurifyOutGetData = p => post('search_purifyout', p); //单据搜索
export const apiPurifyOutAddData = p => post('add_purifyout', p); //新增
export const apiPurifyOutUpdateData = p => post('update_purifyout', p); //修改
export const apiPurifyOutDelData = p => post('del_purifyout', p); //删除
export const apiPurifyOutDelsData = p => post('dels_purifyout', p); //批量删除
export const apiPurifyOutcheck = p => post('check_purifyout', p); //审核
export const apiPurifyOutchecks = p => post('checks_purifyout', p); //批量审核
export const apiPurifyOutPriceAdMate = p => post('reflex_purifyout', p); //结价结料
export const apiPurifyOutTempPrint = p => get('report_purifyout', p); //打印
export const apiPurifyOutGetOrderList = p => post('index_purifyout', p); //单据列表查询
export const apiPurifyOutTotalData = p => post('totalData_purifyout', p); //单据合计数

// 提纯收回管理
export const apiPurifyInGetPull = p => get('pull_purifyin', p); //下拉
export const apiPurifyInGetData = p => post('search_purifyin', p); //单据搜索
export const apiPurifyInAddData = p => post('add_purifyin', p); //新增
export const apiPurifyInUpdateData = p => post('update_purifyin', p); //修改
export const apiPurifyInDelData = p => post('del_purifyin', p); //删除
export const apiPurifyInDelsData = p => post('dels_purifyin', p); //批量删除
export const apiPurifyIncheck = p => post('check_purifyin', p); //审核
export const apiPurifyInchecks = p => post('checks_purifyin', p); //批量审核
export const apiPurifyInPriceAdMate = p => post('reflex_purifyin', p); //结价结料
export const apiPurifyInTempPrint = p => get('report_purifyin', p); //打印
export const apiPurifyInGetOrderList = p => post('index_purifyin', p); //单据列表查询
export const apiPurifyInTotalData = p => post('totalData_purifyin', p); //单据合计数
export const apiPurifyInGetPurifyData = p => get('getPurifyBatch_purifyin', p); //获取提纯批次数据

// 提纯成色管理
export const apiPurifyAlloyGetPull = p => get('pull_purifyalloy', p); //下拉
export const apiPurifyAlloyGetData = p => post('search_purifyalloy', p); //单据搜索
export const apiPurifyAlloyAddData = p => post('add_purifyalloy', p); //新增
export const apiPurifyAlloyUpdateData = p => post('update_purifyalloy', p); //修改
export const apiPurifyAlloyDelData = p => post('del_purifyalloy', p); //删除
export const apiPurifyAlloyDelsData = p => post('dels_purifyalloy', p); //批量删除
export const apiPurifyAlloycheck = p => post('check_purifyalloy', p); //审核
export const apiPurifyAlloychecks = p => post('checks_purifyalloy', p); //批量审核
export const apiPurifyAlloyGetOrderList = p => post('index_purifyalloy', p); //单据列表查询
export const apiPurifyAlloyGetPurifyData = p => get('getPurifyBatch_purifyalloy', p); //获取提纯批次数据


// 加工贸易手册
export const apiCustomsManualGetPull = p => get('pull_customsmanual', p); //下拉
export const apiCustomsManualGetData = p => post('search_customsmanual', p); //单据搜索
export const apiCustomsManualAddData = p => post('add_customsmanual', p); //新增
export const apiCustomsManualUpdateData = p => post('update_customsmanual', p); //修改
export const apiCustomsManualDelData = p => post('del_customsmanual', p); //删除
export const apiCustomsManualDelsData = p => post('dels_customsmanual', p); //批量删除
export const apiCustomsManualcheck = p => post('check_customsmanual', p); //审核
export const apiCustomsManualchecks = p => post('checks_customsmanual', p); //批量审核
export const apiCustomsManualGetOrderList = p => post('index_customsmanual', p); //单据列表查询
export const apiCustomsManualImpDtl = p => post('importdtl_customsmanual', p); // excel导入明细
export const apiCustomsManualTempExport = p => get('template_export_customsmanual', p); // 下载导入模板
//调拨管理
export const apiFirstMove = p => get('movesj_first', p); //第一个调拨
export const apiNextMove = p => get('movesj_next', p); //下一个调拨
export const apiPrevMove = p => get('movesj_prev', p); //上一个调拨
export const apiLastMove = p => get('movesj_last', p); //最后一个调拨
export const apiSearchMove = p => get('movesj_list', p); //查询调拨
export const apiaddMove = p => post('add_movesj', p); //添加调拨
export const apiModifyMove = p => post('update_movesj', p); //修改调拨
export const apiDelMove = p => get('dalete_movesj', p); //删除调拨
export const apiExportMove = p => get('movesj_export', p); //调拨或调拨明细导出
export const apiExportMoveTem = p => get('movesj_template_export', p); //调拨或调拨明细模板导出
export const apiAllSelectMove = p => get('pull_movesj', p); //所有下拉框
export const apiAllSelectincountpull = p => get('incountpull_movesj', p); //门店下拉框
export const apicheckMove = p => get('movesj_check', p); //审核
export const apichooseMove = p => post('screen_movesj', p); //筛选
export const apiPrintMover = p => get('movesj_report', p); //打印
export const apiMoverAllCheck = p => get('all_movesj_check', p); //批量审核
export const movesjGetList = p => get('movesj_get_list', p); //历史列表
export const daleteMovesjs = p => get('dalete_movesjs', p); //批量导出
export const movesj_tag = p => get('movesj_tag', p); //标签打印
export const apiPrintmovesjprintLabel = p => get('printLabel_movesj', p); //标签打印
export const apiGetMoveBarcodeInfo = p => post('getBarcodes_movesj', p); //获取条码数据
export const apiIsAllowUpdateMoveData = p => get('isAllowUpdate_movesj', p); //是否允许修改
export const apiUseSepwgtMovesj = p => get('usebillno_movesj', p); //调拨使用引用单号
// export const apiUseSepwgtMovesj = p => get('usesepwgt_movesj', p); //调拨使用分称单号



//库存调整
export const apiFirstStock = p => get('stockadjust_first', p); //第一个
export const apiNextStock = p => get('stockadjust_next', p); //下一个
export const apiPrevStock = p => get('stockadjust_prev', p); //上一个
export const apiLastStock = p => get('stockadjust_last', p); //最后一个
export const apiSearchStock = p => get('stockadjust_list', p); //查询
export const apiaddStock = p => post('add_stockadjust', p); //添加
export const apiModifyStock = p => post('update_stockadjust', p); //修改
export const apiDelStock = p => get('dalete_stockadjust', p); //删除
export const apiExportStock = p => get('stockadjust_export', p); //导出
export const apiExportStockTem = p => get('stockadjust_template_export', p); //模板导出
export const apiAllSelectStock = p => get('pull_stockadjust', p); //所有下拉框
export const apicheckStock = p => get('stockadjust_check', p); //审核
export const apichooseStock = p => post('screen_stockadjust', p); //筛选
export const apiCounterStock = p => get('counter_style', p); //库存重整
export const apiCounterdataStock = p => get('getStyleStock_stockadjust', p); //选择柜台带出数据
export const apiCounterTable = p => get('getStock_stockadjust', p); //选择柜台带出库存表
export const apiCounterAllCheck = p => get('all_stockadjust_check', p); //批量审核
export const stockadjustGetList = p => get('stockadjust_get_list', p); //历史列表
export const daleteStockadjusts = p => get('dalete_stockadjusts', p); //批量删除


// 金料定价
export const apiGetMetalPricingHisData = p => post("index_MetalPricing", p);//获取分称管理页面数据
export const apiGetMetalPricingData = p => post("search_MetalPricing", p);//获取分称管理页面数据
export const apiGetMetalPricingPull = p => get("pull_MetalPricing", p);//获取下拉
export const apiAddMetalPricingData = p => post("add_MetalPricing", p);//新建数据
export const apiModifyMetalPricingData = p => post("update_MetalPricing", p);//修改数据
export const apiDelMetalPricingData = p => post("del_MetalPricing", p);//删除
export const apiDelMetalPricingDatas = p => post("dels_MetalPricing", p);//批量删除
export const apiCanModifyMetalPricingData = p => post("isAllowUpdate_MetalPricing", p);//是否允许修改和删除
export const apiCheckMetalPricing = p => post("check_MetalPricing", p);//审核
export const apiCheckMetalPricings = p => post("checks_MetalPricing", p);//批量审核
export const apiWriteOffDltMetalPricing = p => post("writeOffDlt_MetalPricing", p);//核销明细
export const apiMetalPricingTempPrint = p => post("report_MetalPricing", p);//打印

// 金料均价统计
export const apiGetMetalAvgPrcCountHisData = p => post("index_MetalAvgPrcCount", p);//获取页面数据
export const apiGetMetalAvgPrcCountData = p => post("search_MetalAvgPrcCount", p);//获取历史单据页面数据
export const apiGetMetalAvgPrcCountPull = p => get("pull_MetalAvgPrcCount", p);//获取下拉
export const apiGetMetalAvgPrcCountQuotedPull = p => get("quotedDatePull_MetalAvgPrcCount", p);
export const apiGetMetalAvgPrcCountQuotedDate = p => post("quotedDateGet_MetalAvgPrcCount", p);
export const apiAddMetalAvgPrcCountData = p => post("add_MetalAvgPrcCount", p);//新建数据
export const apiModifyMetalAvgPrcCountData = p => post("update_MetalAvgPrcCount", p);//修改数据
export const apiDelMetalAvgPrcCountData = p => post("del_MetalAvgPrcCount", p);//删除
export const apiDelMetalAvgPrcCountDatas = p => post("dels_MetalAvgPrcCount", p);//批量删除
export const apiCheckMetalAvgPrcCount = p => post("check_MetalAvgPrcCount", p);//审核
export const apiCheckMetalAvgPrcCounts = p => post("checks_MetalAvgPrcCount", p);//批量审核

// 金料定价结算
export const apiMetalPricingSettleGetPull = p => get('pull_metalpricingsettle', p); //下拉
export const apiMetalPricingSettleGetData = p => post('search_metalpricingsettle', p); //单据搜索
export const apiMetalPricingSettleAddData = p => post('add_metalpricingsettle', p); //新增
export const apiMetalPricingSettleUpdateData = p => post('update_metalpricingsettle', p); //修改
export const apiMetalPricingSettleDelData = p => post('del_metalpricingsettle', p); //删除
export const apiMetalPricingSettleDelsData = p => post('dels_metalpricingsettle', p); //批量删除
export const apiMetalPricingSettlecheck = p => post('check_metalpricingsettle', p); //审核
export const apiMetalPricingSettlechecks = p => post('checks_metalpricingsettle', p); //批量审核
export const apiMetalPricingSettleTempPrint = p => get('report_metalpricingsettle', p); //打印
export const apiMetalPricingSettleGetOrderList = p => post('index_metalpricingsettle', p); //单据列表查询
export const apiMetalPricingSettleTotalData = p => post('totalData_metalpricingsettle', p); //单据合计数
export const apiMetalPricingSettleGetMetalPricingData = p => get('getMetalPricingData_metalpricingsettle', p); //单据合计数
export const apiSettleUsedMetalPricingData = p => post('usedMetalPricingData_metalpricingsettle', p); //使用定价单
export const apiSettleDelMetalPricingData = p => post('delMetalPricingData_metalpricingsettle', p); //删除使用定价单

// 金料定价回购结算
export const apiMetalPricingInSettleGetPull = p => get('pull_metalpricinginsettle', p); //下拉
export const apiMetalPricingInSettleGetData = p => post('search_metalpricinginsettle', p); //单据搜索
export const apiMetalPricingInSettleAddData = p => post('add_metalpricinginsettle', p); //新增
export const apiMetalPricingInSettleUpdateData = p => post('update_metalpricinginsettle', p); //修改
export const apiMetalPricingInSettleDelData = p => post('del_metalpricinginsettle', p); //删除
export const apiMetalPricingInSettleDelsData = p => post('dels_metalpricinginsettle', p); //批量删除
export const apiMetalPricingInSettlecheck = p => post('check_metalpricinginsettle', p); //审核
export const apiMetalPricingInSettlechecks = p => post('checks_metalpricinginsettle', p); //批量审核
export const apiMetalPricingInSettleTempPrint = p => get('report_metalpricinginsettle', p); //打印
export const apiMetalPricingInSettleGetOrderList = p => post('index_metalpricinginsettle', p); //单据列表查询
export const apiMetalPricingInSettleTotalData = p => post('totalData_metalpricinginsettle', p); //单据合计数
export const apiMetalPricingInSettleGetMetalPricingData = p => get('getMetalPricingData_metalpricinginsettle', p); //单据合计数
export const apiInSettleUsedMetalPricingData = p => post('usedMetalPricingData_metalpricinginsettle', p); //使用定价单
export const apiInSettleDelMetalPricingData = p => post('delMetalPricingData_metalpricinginsettle', p); //删除使用定价单

// 金料定价销售结算
export const apiMetalPricingOutSettleGetPull = p => get('pull_metalpricingoutsettle', p); //下拉
export const apiMetalPricingOutSettleGetData = p => post('search_metalpricingoutsettle', p); //单据搜索
export const apiMetalPricingOutSettleAddData = p => post('add_metalpricingoutsettle', p); //新增
export const apiMetalPricingOutSettleUpdateData = p => post('update_metalpricingoutsettle', p); //修改
export const apiMetalPricingOutSettleDelData = p => post('del_metalpricingoutsettle', p); //删除
export const apiMetalPricingOutSettleDelsData = p => post('dels_metalpricingoutsettle', p); //批量删除
export const apiMetalPricingOutSettlecheck = p => post('check_metalpricingoutsettle', p); //审核
export const apiMetalPricingOutSettlechecks = p => post('checks_metalpricingoutsettle', p); //批量审核
export const apiMetalPricingOutSettleTempPrint = p => get('report_metalpricingoutsettle', p); //打印
export const apiMetalPricingOutSettleGetOrderList = p => post('index_metalpricingoutsettle', p); //单据列表查询
export const apiMetalPricingOutSettleTotalData = p => post('totalData_metalpricingoutsettle', p); //单据合计数
export const apiMetalPricingOutSettleGetMetalPricingData = p => get('getMetalPricingData_metalpricingoutsettle', p); //单据合计数
export const apiOutSettleUsedMetalPricingData = p => post('usedMetalPricingData_metalpricingoutsettle', p); //使用定价单
export const apiOutSettleDelMetalPricingData = p => post('delMetalPricingData_metalpricingoutsettle', p); //删除使用定价单

// 委外加工出库
export const apiOutsourcProcessOutGetPull = p => get('pull_outsourcprocessout', p); //下拉
export const apiOutsourcProcessOutGetData = p => post('search_outsourcprocessout', p); //单据搜索
export const apiOutsourcProcessOutAddData = p => post('add_outsourcprocessout', p); //新增
export const apiOutsourcProcessOutUpdateData = p => post('update_outsourcprocessout', p); //修改
export const apiOutsourcProcessOutDelData = p => post('del_outsourcprocessout', p); //删除
export const apiOutsourcProcessOutDelsData = p => post('dels_outsourcprocessout', p); //批量删除
export const apiOutsourcProcessOutcheck = p => post('check_outsourcprocessout', p); //审核
export const apiOutsourcProcessOutchecks = p => post('checks_outsourcprocessout', p); //批量审核
export const apiOutsourcProcessOutPriceAdMate = p => post('reflex_outsourcprocessout', p); //结价结料
export const apiOutsourcProcessOutTempPrint = p => get('report_outsourcprocessout', p); //打印
export const apiOutsourcProcessOutGetOrderList = p => post('index_outsourcprocessout', p); //单据列表查询
export const apiOutsourcProcessOutTotalData = p => post('totalData_outsourcprocessout', p); //单据合计数
export const apiGetProcessItemNoData = p => get('getInItemNo_outsourcprocessout', p); //获取货号数据

// 委外加工入库
export const apiOutsourcProcessInGetPull = p => get('pull_outsourcprocessin', p); //下拉
export const apiOutsourcProcessInGetData = p => post('search_outsourcprocessin', p); //单据搜索
export const apiOutsourcProcessInAddData = p => post('add_outsourcprocessin', p); //新增
export const apiOutsourcProcessInUpdateData = p => post('update_outsourcprocessin', p); //修改
export const apiOutsourcProcessInDelData = p => post('del_outsourcprocessin', p); //删除
export const apiOutsourcProcessInDelsData = p => post('dels_outsourcprocessin', p); //批量删除
export const apiOutsourcProcessIncheck = p => post('check_outsourcprocessin', p); //审核
export const apiOutsourcProcessInchecks = p => post('checks_outsourcprocessin', p); //批量审核
export const apiOutsourcProcessInPriceAdMate = p => post('reflex_outsourcprocessin', p); //结价结料
export const apiOutsourcProcessInTempPrint = p => get('report_outsourcprocessin', p); //打印
export const apiOutsourcProcessInGetOrderList = p => post('index_outsourcprocessin', p); //单据列表查询
export const apiOutsourcProcessInTotalData = p => post('totalData_outsourcprocessin', p); //单据合计数
export const apiOutsourcProcessInGetCost = p => get('getStyleCost_outsourcprocessin', p); //获取产品成本价

// 分称管理
export const apiGetDividedData = p => post("search_sepwgt", p);//获取分称管理页面数据
export const apiAddDividedData = p => post("add_sepwgt", p);//新建数据
export const apiModifyDividedData = p => post("update_sepwgt", p);//修改数据
export const apiCheckDivided = p => post("check_sepwgt", p);//审核
export const apiCheckDivideds = p => post("checks_sepwgt", p);//批量审核
export const apiGetDividedPull = p => get("pull_sepwgt", p);//获取下拉
export const apiCanModifyDividedData = p => post("isAllowUpdate_sepwgt", p);//是否允许修改和删除
export const apiDelDividedData = p => post("del_sepwgt", p);//删除
export const apiDelDividedDatas = p => post("dels_sepwgt", p);//批量删除
export const apiGetDividedHisTable = p => get("word_list_sepwgt", p);//获取历史单据列表字段
export const apiUpDividedHisData = p => post("word_update_sepwgt", p);//修改历史单据列表
export const apiGetDividedHisData = p => post("index_sepwgt", p);//获取历史单据列表
export const apiGetDividedBtnInfo = p => get("usein_sepwgt", p);//获取分称按钮信息
export const apiIsOrderQuote = p => get("isUseIn_sepwgt", p);//判断单据是否被引用


// 条码信息调整
export const apiGetInfoAdjustData = p => post("search_updatebarcodes", p);//获取页面数据
export const apiGetInfoAdjustDataImportdtl = p => post("importdtl_updatebarcodes", p);//导入
export const apiGetInfoAdjustBroadData = p => post("getBarcodes_updatebarcodes", p);//获取条码信息
export const apiAddInfoAdjustData = p => post("add_updatebarcodes", p);//新建数据
export const apiModifyInfoAdjustData = p => post("update_updatebarcodes", p);//修改数据
export const apiCheckInfoAdjust = p => post("check_updatebarcodes", p);//审核
export const apiCheckInfoAdjusts = p => post("checks_updatebarcodes", p);//批量审核
export const apiGetInfoAdjustPull = p => get("pull_updatebarcodes", p);//获取下拉
export const apiCanModifyInfoAdjustData = p => post("isAllowUpdate_updatebarcodes", p);//是否允许修改和删除
export const apiDelInfoAdjustData = p => post("del_updatebarcodes", p);//删除
export const apiDelInfoAdjustDatas = p => post("dels_updatebarcodes", p);//批量删除
export const apiGetInfoAdjustHisTable = p => get("word_list_updatebarcodes", p);//获取历史单据列表字段
export const apiUpInfoAdjustHisData = p => post("word_update_updatebarcodes", p);//修改历史单据列表
export const apiGetInfoAdjustHisData = p => post("index_updatebarcodes", p);//获取历史单据列表
export const apiInfoAdjustData = p => post('printLabel_updatebarcodes', p); //获取打印链接-分称
export const apiInfoAdjustDataExport = (p) => {
  return axios({
    url: baseURL + 'printLabel_updatebarcodes',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};



// 条码履历
export const apiGetBarcodeHistoryData = p => post("search_barcoderecord", p);// 获取条码履历数据
export const apiGetBarcodeHistory = p => post('printLabel_barcoderecord', p); //获取打印链接-分称
export const apiGetBarcodeHistoryExport = (p) => {
  return axios({
    url: baseURL + 'printLabel_barcoderecord',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};



// 库存管理综合报表


// 进销存表
export const apiInSale = p => post('inOutStock_Rpt', p); //列表信息
export const apiInSalePull = p => get('inOutStock_pull_Rpt', p); //下拉
export const apiInSaleExport = (p) => {
  return axios({
    url: baseURL + 'inOutStock_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
// 金料提纯统计表
export const apiMetalPurifyRpt = p => post('metalPurify_Rpt', p); //列表信息
export const apiMetalPurifyRptPull = p => get('metalPurify_pull_Rpt', p); //下拉
export const apiMetalPurifyRptExport = (p) => {
  return axios({
    url: baseURL + 'metalPurify_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};

// 委外加工统计表
export const apiOutsourcProcessRpt = p => post('outsourcProcess_Rpt', p); //列表信息
export const apiOutsourcProcessRptPull = p => get('outsourcProcess_pull_Rpt', p); //下拉
export const apiOutsourcProcessRptExport = (p) => {
  return axios({
    url: baseURL + 'outsourcProcess_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};

// 库存表
export const apitotalTable = p => post('allStock_Rpt', p); //列表信息
export const apitotalTablePull = p => get('allStock_pull_Rpt', p); //下拉
export const apitotalTableExport = (p) => {
  return axios({
    url: baseURL + 'allStock_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
// 库存表-按品类
export const apiStockType = p => post('stockType_Rpt', p); //列表信息
export const apiStockTypePull = p => get('stockType_pull_Rpt', p); //下拉
export const apiStockTypeExport = (p) => {
  return axios({
    url: baseURL + 'stockType_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
// 货号库存表
export const apiItemNoStockRpt = p => post('getDate_itemNoStockRpt', p); //列表信息
export const apiItemNoStockRptPull = p => get('pull_itemNoStockRpt', p); //下拉
export const apiItemNoStockRptExport = (p) => {
  return axios({
    url: baseURL + 'getDate_itemNoStockRpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
// 货号库存明细表
export const apiItemNoStockDtlRpt = p => post('getDate_itemNoStockDtlRpt', p); //列表信息
export const apiItemNoStockDtlRptPull = p => get('pull_itemNoStockDtlRpt', p); //下拉
export const apiItemNoStockDtlRptExport = (p) => {
  return axios({
    url: baseURL + 'getDate_itemNoStockDtlRpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
// 销售利润表
export const apiprofitRep = p => post('profit_rep', p); //列表信息
export const apiprofitCust = p => get('Tocust_list', p); //列表信息
export const apiprofitRepPull = p => get('profit_rep_pull', p); //下拉


// 来料统计表
export const apiComTotal = p => post('report_inliset_total', p); //列表信息
export const apiComTotalPull = p => get('inliset_total_pull', p); //下拉
//销售明细
export const apiSaleDetail = p => post('saleliset', p); //列表信息
export const apiSaleDetailPull = p => get('saleliset_pull', p); //下拉

// 条码库存表
export const apiBarcode = p => post("barcodeStock_Rpt", p); // 列表
export const apiBarcodePull = p => get("barcodeStock_pull_Rpt", p); // 下拉
export const apiBarcodeExport = (p) => {
  return axios({
    url: baseURL + 'barcodeStock_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
// 金包银库存表
export const apiGoldsilver = p => post("goldSilverStock_Rpt", p); // 列表
export const apiGoldsilverPull = p => get("goldSilverStock_pull_Rpt", p); // 下拉
export const apiGoldsilverExport = (p) => {
  return axios({
    url: baseURL + 'goldSilverStock_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
// 订购明细表
export const apiOrderSale = p => post('subDtl_Rpt', p); //列表信息
export const apiOrderSalePull = p => get('subDtl_pull_Rpt', p); //下拉
export const apiOrderSaleExport = (p) => {
  return axios({
    url: baseURL + 'subDtl_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
// 调拨明细表
export const apiMoveDtl = p => post('movesjDtl_Rpt', p); //列表信息
export const apiMovePull = p => get('movesjDtl_pull_Rpt', p); //下拉
export const apiMoveExport = (p) => {
  return axios({
    url: baseURL + 'movesjDtl_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
// 调拨汇总表
export const apiMoveTotalDtl = p => post('movesjTotal_Rpt', p); //列表信息
export const apiMoveTotalPull = p => get('movesjTotal_pull_Rpt', p); //下拉
export const apiMoveTotalExport = (p) => {
  return axios({
    url: baseURL + 'movesjTotal_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};

// 入库明细表
export const apiComin = p => post('inDtl_Rpt', p); //列表信息
export const apiCominPull = p => get('inDtl_pull_Rpt', p); //下拉
export const apiCominExport = (p) => {
  return axios({
    url: baseURL + 'inDtl_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};

// 入库汇总表-按客户
export const apiCominCust = p => post('inTotalCust_Rpt', p); //列表信息
export const apiCominCustPull = p => get('inTotalCust_pull_Rpt', p); //下拉
export const apiCominCustExport = (p) => {
  return axios({
    url: baseURL + 'inTotalCust_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};

// 入库汇总表-按产品
export const apiCominStyle = p => post('inTotalStyle_Rpt', p); //列表信息
export const apiCominStylePull = p => get('inTotalStyle_pull_Rpt', p); //下拉
export const apiCominStyleExport = (p) => {
  return axios({
    url: baseURL + 'inTotalStyle_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};

//新出库明细
export const apiOutDtl = p => post('outDtl_Rpt', p); //列表信息
export const apiOutDtlPull = p => get('outDtl_pull_Rpt', p); //下拉
export const apiOutDtlExport = (p) => {
  return axios({
    url: baseURL + 'outDtl_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
//新出库明细-按客户
export const apiOutDtlCust = p => post('outTotalCust_Rpt', p); //列表信息
export const apiOutDtlCustPull = p => get('outTotalCust_pull_Rpt', p); //下拉
export const apiOutDtlCustExport = (p) => {
  return axios({
    url: baseURL + 'outTotalCust_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
//新出库明细-按业务员
export const apiOutDtlSaleman = p => post('outTotalSaleman_Rpt', p); //列表信息
export const apiOutDtlSalemanPull = p => get('outTotalSaleman_pull_Rpt', p); //下拉
export const apiOutDtlSalemanExport = (p) => {
  return axios({
    url: baseURL + 'outTotalSaleman_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
//新出库明细-按产品
export const apiOutDtlStyle = p => post('outTotalStyle_Rpt', p); //列表信息
export const apiOutDtlStylePull = p => get('outTotalStyle_pull_Rpt', p); //下拉
export const apiOutDtlStyleExport = (p) => {
  return axios({
    url: baseURL + 'outTotalStyle_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
//出入库单据明细表
export const apiOutInStock = p => post('inOutDtl_Rpt', p); //列表信息
export const apiOutInStockPull = p => get('inOutDtl_pull_Rpt', p); //下拉
export const apiOutInStockExport = (p) => {
  return axios({
    url: baseURL + 'inOutDtl_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
//出入库账款明细表
export const apiOutInAccount = p => post('inOutAccount_Rpt', p); //列表信息
export const apiOutInAccountPull = p => get('inOutAccount_pull_Rpt', p); //下拉
export const apiOutInAccountExport = (p) => {
  return axios({
    url: baseURL + 'inOutAccount_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
//出入库账单据列表
export const apiInOutBillList = p => post('inOutBillList_Rpt', p); //列表信息
export const apiInOutBillListPull = p => get('inOutBillList_pull_Rpt', p); //下拉
export const apiInOutBillListExport = (p) => {
  return axios({
    url: baseURL + 'inOutBillList_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
//工费汇总表-按业务员
export const apiWageTotalSaleman = p => post('wageTotalSaleman_Rpt', p); //列表信息
export const apiWageTotalSalemanPull = p => get('wageTotalSaleman_pull_Rpt', p); //下拉
export const apiWageTotalSalemanExport = (p) => {
  return axios({
    url: baseURL + 'wageTotalSaleman_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
//提纯明细表
export const apiPurifyDtlRpt = p => post('PurifyDtlRpt_jzf', p); //列表信息
export const apiPurifyDtlRptPull = p => get('PurifyDtlPull_jzf', p); //下拉
export const apiPurifyDtlRptExport = (p) => {
  return axios({
    url: baseURL + 'PurifyDtlRpt_jzf',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
//提纯日报表
export const apiPurifyDailyRpt = p => post('PurifyDailyRpt_jzf', p); //列表信息
export const apiPurifyDailyRptPull = p => get('PurifyDailyPull_jzf', p); //下拉
export const apiPurifyDailyRptExport = (p) => {
  return axios({
    url: baseURL + 'PurifyDailyRpt_jzf',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
//购料日报表
export const apiPurcDailyRpt = p => post('PurcDailyRpt_jzf', p); //列表信息
export const apiPurcDailyRptPull = p => get('PurcDailyPull_jzf', p); //下拉
export const apiPurcDailyRptExport = (p) => {
  return axios({
    url: baseURL + 'PurcDailyRpt_jzf',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
//汇总日报表
export const apiCompDailyRpt = p => post('CompDailyRpt_jzf', p); //列表信息
export const apiCompDailyRptPull = p => get('CompDailyPull_jzf', p); //下拉
export const apiCompDailyRptExport = (p) => {
  return axios({
    url: baseURL + 'CompDailyRpt_jzf',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};


// 账款管理综合报表

// 配货销售利润表-按客户
export const apiDistSalesProfitCustRpt = p => post('distSalesProfitCust_Rpt', p); //列表信息
export const apiDistSalesProfitCustRptPull = p => get('distSalesProfitCust_pull_Rpt', p); //下拉
export const apiDistSalesProfitCustRptExport = (p) => {
  return axios({
    url: baseURL + 'distSalesProfitCust_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
// 配货销售利润表-按产品
export const apiDistSalesProfitStyleRpt = p => post('distSalesProfitStyle_Rpt', p); //列表信息
export const apiDistSalesProfitStyleRptPull = p => get('distSalesProfitStyle_pull_Rpt', p); //下拉
export const apiDistSalesProfitStyleRptExport = (p) => {
  return axios({
    url: baseURL + 'distSalesProfitStyle_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
// 配货销售利润表-按单据
export const apiDistSalesProfitBillRpt = p => post('distSalesProfitBill_Rpt', p); //列表信息
export const apiDistSalesProfitBillRptPull = p => get('distSalesProfitBill_pull_Rpt', p); //下拉
export const apiDistSalesProfitBillRptExport = (p) => {
  return axios({
    url: baseURL + 'distSalesProfitBill_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};


//定价结算明细表
export const apiPricingSettleDtlRpt = p => post('pricingSettleDtl_Rpt', p); //列表信息
export const apiPricingSettleDtlRptPull = p => get('pricingSettleDtl_pull_Rpt', p); //下拉
export const apiPricingSettleDtlRptExport = (p) => {
  return axios({
    url: baseURL + 'pricingSettleDtl_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
//定价未结明细表
export const apiPricingUnSettleDtlRpt = p => post('pricingUnSettleDtl_Rpt', p); //列表信息
export const apiPricingUnSettleDtlRptPull = p => get('pricingUnSettleDtl_pull_Rpt', p); //下拉
export const apiPricingUnSettleDtlRptExport = (p) => {
  return axios({
    url: baseURL + 'pricingUnSettleDtl_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
export const apiPricingUnSettleTotalStyleRpt = p => post('pricingUnSettleTotalStyle_Rpt', p); //列表信息
export const apiPricingUnSettleTotalStyleRptPull = p => get('pricingUnSettleTotalStyle_pull_Rpt', p); //下拉
export const apiPricingUnSettleTotalStyleRptExport = (p) => {
  return axios({
    url: baseURL + 'pricingUnSettleTotalStyle_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
export const apiPricingUnSettleTotalCustRpt = p => post('pricingUnSettleTotalCust_Rpt', p); //列表信息
export const apiPricingUnSettleTotalCustRptPull = p => get('pricingUnSettleTotalCust_pull_Rpt', p); //下拉
export const apiPricingUnSettleTotalCustRptExport = (p) => {
  return axios({
    url: baseURL + 'pricingUnSettleTotalCust_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
//定价明细表
export const apiMetalPricingDtlRpt = p => post('metalPricingDtl_Rpt', p); //列表信息
export const apiMetalPricingDtlRptPull = p => get('metalPricingDtl_pull_Rpt', p); //下拉
export const apiMetalPricingDtlRptExport = (p) => {
  return axios({
    url: baseURL + 'metalPricingDtl_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
// 资产负债表
export const apiBalanceSheetRpt = p => post('balanceSheet_Rpt', p); //列表信息
export const apiBalanceSheetRptPull = p => get('balanceSheet_pull_Rpt', p); //下拉
export const apiBalanceSheetRptExport = (p) => {
  return axios({
    url: baseURL + 'balanceSheet_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
//工费汇总
// 客户存欠总表-按客户
export const apiCustTotal = p => post('accTotalCust_Rpt', p); //列表信息
export const apiCustTotalPull = p => get('accTotalCust_pull_Rpt', p); //下拉
export const apiCustTotalExport = (p) => {
  return axios({
    url: baseURL + 'accTotalCust_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
// 客户存欠日报表
export const apiAssetDay = p => post('assetDay_Rpt', p); //列表信息
export const apiAssetDayPull = p => get('assetDay_pull_Rpt', p); //下拉
export const apiAssetDayExport = (p) => {
  return axios({
    url: baseURL + 'assetDay_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};

// 客户存欠总表-按业务员
export const apiCustTotalSaleman = p => post('accTotalSaleman_Rpt', p); //列表信息
export const apiCustTotalSalemanPull = p => get('accTotalSaleman_pull_Rpt', p); //下拉
export const apiCustTotalSalemanExport = (p) => {
  return axios({
    url: baseURL + 'accTotalSaleman_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
// 客户存欠总表-按产品
export const apiCustTotalStyle = p => post('accTotalStyle_Rpt', p); //列表信息
export const apiCustTotalStylePull = p => get('accTotalStyle_pull_Rpt', p); //下拉
export const apiCustTotalStyleExport = (p) => {
  return axios({
    url: baseURL + 'accTotalStyle_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
// 客户对账单-按产品
export const apiCustDtlStyle = p => post('accDtlStyle_Rpt', p); //列表信息
export const apiCustDtlStylePull = p => get('accDtlStyle_pull_Rpt', p); //下拉
export const apiCustDtlStyleExport = (p) => {
  return axios({
    url: baseURL + 'accDtlStyle_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
// 客户对账单-按单据
export const apiCustDtlBill = p => post('accDtlBill_Rpt', p); //列表信息
export const apiCustDtlBillPull = p => get('accDtlBill_pull_Rpt', p); //下拉
export const apiCustDtlBillExport = (p) => {
  return axios({
    url: baseURL + 'accDtlBill_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};


// 账户收支明细表
export const apiAccountDtlBill = p => post('incExpDtl_Rpt', p); //列表信息
export const apiAccountDtlBillPull = p => get('incExpDtl_pull_Rpt', p); //下拉
export const apiAccountDtlBillExport = (p) => {
  return axios({
    url: baseURL + 'incExpDtl_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};

// 金料均价统计表
export const apiMetalAvgPrcCountRpt = p => post('metalAvgPrcCount_Rpt', p); //列表信息
export const apiMetalAvgPrcCountRptPull = p => get('metalAvgPrcCount_pull_Rpt', p); //下拉
export const apiMetalAvgPrcCountRptExport = (p) => {
  return axios({
    url: baseURL + 'metalAvgPrcCount_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};

export const apiMetalAvgPrcCountTotalRpt = p => post('metalAvgPrcCountTotal_Rpt', p); //列表信息
export const apiMetalAvgPrcCountRptTotalExport = (p) => {
  return axios({
    url: baseURL + 'metalAvgPrcCountTotal_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
// 结价明细表
export const apiPricedtl = p => post('balprcDtl_Rpt', p); //列表信息
export const apiPricedtlPull = p => get('balprcDtl_pull_Rpt', p); //下拉
export const apiPricedtlExport = (p) => {
  return axios({
    url: baseURL + 'balprcDtl_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
// 结价汇总表-按产品
export const apiBalprcTotalStyle = p => post('balprcTotalStyle_Rpt', p); //列表信息
export const apiBalprcTotalStylePull = p => get('balprcTotalStyle_pull_Rpt', p); //下拉
export const apiBalprcTotalStyleExport = (p) => {
  return axios({
    url: baseURL + 'balprcTotalStyle_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
// 客户利息表
export const apiCustList = p => post('custInt_Rpt', p); //列表信息
export const apiCustListPull = p => get('custInt_pul_Rpt', p); //下拉
export const apiCustListExport = (p) => {
  return axios({
    url: baseURL + 'custInt_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
// 客户仓息表
export const apiCustStock = p => post('custStockInt_Rpt', p); //列表信息
export const apiCustStockPull = p => get('custStockInt_pul_Rpt', p); //下拉
export const apiCustStockExport = (p) => {
  return axios({
    url: baseURL + 'custStockInt_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
// 条码工费利润表
export const apiBarcodeWageProfit = p => post('barcodeWageProfit_Rpt', p); //列表信息
export const apiBarcodeWageProfitPull = p => get('barcodeWageProfit_pull_Rpt', p); //下拉
export const apiBarcodeWageProfitExport = (p) => {
  return axios({
    url: baseURL + 'barcodeWageProfit_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
// 条码销售利润表
export const apiBarcodeSaleProfit= p => post('barcodeSaleProfit_Rpt', p); //列表信息
export const apiBarcodeSaleProfitPull = p => get('barcodeSaleProfit_pull_Rpt', p); //下拉
export const apiBarcodeSaleProfitExport = (p) => {
  return axios({
    url: baseURL + 'barcodeSaleProfit_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
// 金包银销售利润表
export const apiGoldsilverSaleProfit = p => post('goldsilverSaleProfit_Rpt', p); //列表信息
export const apiGoldsilverSaleProfitPull = p => get('goldsilverSaleProfit_pull_Rpt', p); //下拉
export const apiGoldsilverSaleProfitExport = (p) => {
  return axios({
    url: baseURL + 'goldsilverSaleProfit_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
// 金包银工费利润表
export const apiGoldsilverWageProfit = p => post('goldsilverWageProfit_Rpt', p); //列表信息
export const apiGoldsilverWageProfitPull = p => get('goldsilverWageProfit_pull_Rpt', p); //下拉
export const apiGoldsilverWageProfitExport = (p) => {
  return axios({
    url: baseURL + 'goldsilverWageProfit_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};

// 素金利润表
export const apiSjProfitRpt_Rpt = p => post('sjProfitRpt_Rpt', p); //列表信息
export const apiSjProfitRpt_RptPull = p => get('sjProfitRpt_pull_Rpt', p); //下拉
export const apiSjProfitRpt_RptExport = (p) => {
  return axios({
    url: baseURL + 'sjProfitRpt_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
// 素金销售结价利润表
export const apiSjSaleBalprcProfit = p => post('sjSaleBalprcProfitRpt_Rpt', p); //列表信息
export const apiSjSaleBalprcProfitPull = p => get('sjSaleBalprcProfitRpt_pull_Rpt', p); //下拉
export const apiSjSaleBalprcProfitExport = (p) => {
  return axios({
    url: baseURL + 'sjSaleBalprcProfitRpt_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
// 素金成本明细表
export const apiSjCostDtl = p => post('sjCostDtlRpt_Rpt', p); //列表信息
export const apiSjCostDtlPull = p => get('sjCostDtlRpt_pull_Rpt', p); //下拉
export const apiSjCostDtlExport = (p) => {
  return axios({
    url: baseURL + 'sjCostDtlRpt_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};

// 素金销售利润表-按单据
export const apiSjProfitRpt_RptBill = p => post('sjSaleBillProfitRpt_Rpt', p); //列表信息
export const apiSjProfitRpt_RptBillPull = p => get('sjSaleBillProfitRpt_pull_Rpt', p); //下拉
export const apiSjProfitRpt_RptBillExport = (p) => {
  return axios({
    url: baseURL + 'sjSaleBillProfitRpt_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
// 持仓头寸统计表
export const apiOpenPositionRpt = p => post('openPosition_Rpt', p); //列表信息
export const apiOpenPositionRptPull = p => get('openPosition_pull_Rpt', p); //下拉
export const apiOpenPositionRptExport = (p) => {
  return axios({
    url: baseURL + 'openPosition_Rpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};
// 收付款明细表
export const apiCollectPay = p => post('bankaccount', p); //列表信息
export const apiCollectPayPull = p => get('bankaccount_pull', p); //下拉
// 现金银行账明细表
export const apiMoneyBank = p => post('bank_account', p); //列表信息
export const apiMoneyBankPull = p => get('bank_account_pull', p); //下拉

//结价管理
export const apiFirstOver = p => get('balprc_first', p); //第一个
export const apiNextOver = p => get('balprc_next', p); //下一个
export const apiPrevOver = p => get('balprc_prev', p); //上一个
export const apiLastOver = p => get('balprc_last', p); //最后一个
export const apiSearchOver = p => get('balprc_list', p); //查询
export const apiaddOver = p => post('add_balprc', p); //添加
export const apiModifyOver = p => post('update_balprc', p); //修改
export const apiDelOver = p => get('dalete_balprc', p); //删除
export const apiExportOver = p => get('balprc_export', p); //导出
export const apiExportOverTem = p => get('balprc_template_export', p); //模板导出
export const apiAllSelectOver = p => get('pull_balprc', p); //所有下拉框
export const apicheckOver = p => get('balprc_check', p); //审核
export const apichooseOver = p => post('screen_balprc', p); //筛选
export const apiCustOver = p => get('currency_mtrstock', p); //选择客户带出数据
export const apiPrintOver = p => get('balprc_report', p); //打印

export const allBalprcCheck = p => get('all_balprc_check', p); //批量审核
export const balprcGetList = p => get('balprc_get_list', p); //历史单据列表
export const daletesBalprc = p => get('daletes_balprc', p); //批量删除
export const balprcStypePrice = p => get('balprc_stype_price', p); //获取金价

export const apiBalprcUsedMetalPricingData = p => post('usedMetalPricingData_balprc', p); //使用定价单
export const apiBalprcDelMetalPricingData = p => post('delMetalPricingData_balprc', p); //删除使用定价单
export const apiBalprcGetMetalPricingData = p => get('getMetalPricingData_balprc', p); // 获取可以使用的定价单


// 存欠料账结价
export const apiMetalBalanceSettleGetPull = p => get('pull_metalbalancesettle', p); //下拉
export const apiMetalBalanceSettleGetData = p => post('search_metalbalancesettle', p); //单据搜索
export const apiMetalBalanceSettleAddData = p => post('add_metalbalancesettle', p); //新增
export const apiMetalBalanceSettleUpdateData = p => post('update_metalbalancesettle', p); //修改
export const apiMetalBalanceSettleDelData = p => post('del_metalbalancesettle', p); //删除
export const apiMetalBalanceSettleDelsData = p => post('dels_metalbalancesettle', p); //批量删除
export const apiMetalBalanceSettlecheck = p => post('check_metalbalancesettle', p); //审核
export const apiMetalBalanceSettlechecks = p => post('checks_metalbalancesettle', p); //批量审核
export const apiMetalBalanceSettleTempPrint = p => get('report_metalbalancesettle', p); //打印
export const apiMetalBalanceSettleGetOrderList = p => post('index_metalbalancesettle', p); //单据列表查询
export const apiMetalBalanceSettleTotalData = p => post('totalData_metalbalancesettle', p); //单据合计数
export const apiMetalBalanceSettleGetMetalPricingData = p => get('getMetalPricingData_metalbalancesettle', p); //获取定价单
export const apiMetalBalanceSettleUsedMetalPricingData = p => post('usedMetalPricingData_metalbalancesettle', p); //使用定价单
export const apiMetalBalanceSettleDelMetalPricingData = p => post('delMetalPricingData_metalbalancesettle', p); //删除使用定价单


//收款管理
export const apiFirstCollect = p => get('collection_first', p); //第一个
export const apiNextCollect = p => get('collection_next', p); //下一个
export const apiPrevCollect = p => get('collection_prev', p); //上一个
export const apiLastCollect = p => get('collection_last', p); //最后一个
export const apiSearchCollect = p => get('collection_list', p); //查询
export const apiaddCollect = p => post('add_collection', p); //添加
export const apiModifyCollect = p => post('update_collection', p); //修改
export const apiDelCollect = p => get('dalete_collection', p); //删除
export const apiExportCollect = p => get('collection_export', p); //导出
export const apiExportCollectTem = p => get('collection_template_export', p); //模板导出
export const apiAllSelectCollect = p => get('pull_collection', p); //所有下拉框
export const apicheckCollect = p => get('collection_check', p); //审核
export const apichooseCollect = p => post('screen_collection', p); //筛选
export const apiPrintCollect = p => get('collection_report', p); //打印
export const apiCollectImport = p => post('collection_import', p); //导入

export const collectionGetList = p => get('collection_get_list', p); //历史单据列表
export const daletesCollection = p => get('daletes_collection', p); //批量删除
export const allCollectionCheck = p => get('all_collection_check', p); //批量审核


//付款管理
export const apiFirstPay = p => get('payment_first', p); //第一个
export const apiNextPay = p => get('payment_next', p); //下一个
export const apiPrevPay = p => get('payment_prev', p); //上一个
export const apiLastPay = p => get('payment_last', p); //最后一个
export const apiSearchPay = p => get('payment_list', p); //查询
export const apiaddPay = p => post('add_payment', p); //添加
export const apiModifyPay = p => post('update_payment', p); //修改
export const apiDelPay = p => get('dalete_payment', p); //删除
export const apiExportPay = p => get('payment_export', p); //导出
export const apiExportPayTem = p => get('payment_template_export', p); //模板导出
export const apiAllSelectPay = p => get('pull_payment', p); //所有下拉框
export const apicheckPay = p => get('payment_check', p); //审核
export const apichoosePay = p => post('screen_payment', p); //筛选
export const apiPrintPay = p => get('payment_report', p); //打印
export const apiPayAllImport = p => post('payment_import', p); //导入

export const paymentGetList = p => get('payment_get_list', p); //历史单据列表
export const daletesPayment = p => get('daletes_payment', p); //批量删除
export const allPaymentCheck = p => get('all_payment_check', p); //批量审核

//账款调整
export const apiFirstAdjust = p => get('accountadjust_first', p); //第一个
export const apiNextAdjust = p => get('accountadjust_next', p); //下一个
export const apiPrevAdjust = p => get('accountadjust_prev', p); //上一个
export const apiLastAdjust = p => get('accountadjust_last', p); //最后一个
export const apiSearchAdjust = p => get('accountadjust_list', p); //查询
export const apiaddAdjust = p => post('add_accountadjust', p); //添加
export const apiModifyAdjust = p => post('update_accountadjust', p); //修改
export const apiDelAdjust = p => get('dalete_accountadjust', p); //删除
export const apiExportAdjust = p => get('accountadjust_export', p); //导出
export const apiExportAdjustTem = p => get('accountadjust_template_export', p); //模板导出
export const apiAllSelectAdjust = p => get('pull_accountadjust', p); //所有下拉框
export const apicheckAdjust = p => get('accountadjust_check', p); //审核
export const apichooseAdjust = p => post('screen_accountadjust', p); //筛选
export const apiAdjustinfo = p => get('cust_money', p); //客户钱帐信息
export const apiPrintAdjust = p => get('accountadjust_report', p); //打印
export const accountadjustImport = p => post('accountadjust_import', p); //导入

export const allAccountadjustCheck = p => get('all_accountadjust_check', p); //批量审核
export const accountAdjustGetList = p => get('accountadjust_get_list', p); //历史单据列表
export const daletesAccountadjust = p => get('daletes_accountadjust', p); //批量删除
//银行过账
export const apiFirstBank = p => get('banktransfer_first', p); //第一个
export const apiNextBank = p => get('banktransfer_next', p); //下一个
export const apiPrevBank = p => get('banktransfer_prev', p); //上一个
export const apiLastBank = p => get('banktransfer_last', p); //最后一个
export const apiSearchBank = p => get('banktransfer_list', p); //查询
export const apiaddBank = p => post('add_banktransfer', p); //添加
export const apiModifyBank = p => post('update_banktransfer', p); //修改
export const apiDelBank = p => get('dalete_banktransfer', p); //删除
export const apiExportBank = p => get('banktransfer_export', p); //导出
export const apiExportBankTem = p => get('banktransfer_template_export', p); //模板导出
export const apiAllSelectBank = p => get('pull_banktransfer', p); //所有下拉框
export const apicheckBank = p => get('banktransfer_check', p); //审核
export const apichooseBank = p => post('screen_banktransfer', p); //筛选
export const apiBankAllCheck = p => get('all_banktransfer_check', p); //批量审核

export const banktransferIndex = p => get('banktransfer_index', p); //新列表
export const banktransferImportr = p => post('banktransfer_importr', p); //导出






//货币转换
export const apiFirstCurrency = p => get('currencytrans_first', p); //第一个
export const apiNextCurrency = p => get('currencytrans_next', p); //下一个
export const apiPrevCurrency = p => get('currencytrans_prev', p); //上一个
export const apiLastCurrency = p => get('currencytrans_last', p); //最后一个
export const apiSearchCurrency = p => get('currencytrans_list', p); //查询
export const apiaddCurrency = p => post('add_currencytrans', p); //添加
export const apiModifyCurrency = p => post('update_currencytrans', p); //修改
export const apiDelCurrency = p => get('dalete_currencytrans', p); //删除
export const apiExportCurrency = p => get('currencytrans_export', p); //导出
export const apiExportCurrencyTem = p => get('currencytrans_template_export', p); //模板导出
export const apiAllSelectCurrency = p => get('pull_currencytrans', p); //所有下拉框
export const apicheckCurrency = p => get('currencytrans_check', p); //审核
export const apichooseCurrency = p => post('screen_currencytrans', p); //筛选
export const apiCurrencyAllCheck = p => get('all_currencytrans_check', p); //批量审核



export const currencytransGetList = p => get('currencytrans_get_list', p); //历史单据列表
export const daletesCurrencytrans = p => get('daletes_currencytrans', p); //批量删除
export const allCurrencytransCheck = p => get('all_currencytrans_check', p); //批量审核
//货料转换
export const apiFirstCargo = p => get('cargotrans_first', p); //第一个
export const apiNextCargo = p => get('cargotrans_next', p); //下一个
export const apiPrevCargo = p => get('cargotrans_prev', p); //上一个
export const apiLastCargo = p => get('cargotrans_last', p); //最后一个
export const apiSearchCargo = p => get('cargotrans_list', p); //查询
export const apiaddCargo = p => post('add_cargotrans', p); //添加
export const apiModifyCargo = p => post('update_cargotrans', p); //修改
export const apiDelCargo = p => get('dalete_cargotrans', p); //删除
export const apiExportCargo = p => get('cargotrans_export', p); //导出
export const apiExportCargoTem = p => get('cargotrans_template_export', p); //模板导出
export const apiAllSelectCargo = p => get('pull_cargotrans', p); //所有下拉框
export const apicheckCargo = p => get('cargotrans_check', p); //审核
export const apichooseCargo = p => post('screen_cargotrans', p); //筛选
export const apiPrintCargo = p => get('cargotrans_report', p); //打印
export const apiCargoAllCheck = p => get('all_cargotrans_check', p); //批量审核

export const cargotransGetList = p => get('cargotrans_get_list', p); //历史单据列表
export const daletesCargotrans = p => get('daletes_cargotrans', p); //批量删除
export const allCargotransCheck = p => get('all_cargotrans_check', p); //批量审核

//货料调整
export const apiFirstCargoAdjust = p => get('cargoadjust_first', p); //第一个
export const apiNextCargoAdjust = p => get('cargoadjust_next', p); //下一个
export const apiPrevCargoAdjust = p => get('cargoadjust_prev', p); //上一个
export const apiLastCargoAdjust = p => get('cargoadjust_last', p); //最后一个
export const apiSearchCargoAdjust = p => get('cargoadjust_list', p); //查询
export const apiaddCargoAdjust = p => post('add_cargoadjust', p); //添加
export const apiModifyCargoAdjust = p => post('update_cargoadjust', p); //修改
export const apiDelCargoAdjust = p => get('dalete_cargoadjust', p); //删除
export const apiExportCargoAdjust = p => get('cargoadjust_export', p); //导出
export const apiExportCargoAdjustTem = p => get('cargoadjust_template_export', p); //模板导出
export const apiAllSelectCargoAdjust = p => get('pull_cargoadjust', p); //所有下拉框
export const apicheckCargoAdjust = p => get('cargoadjust_check', p); //审核
export const apichooseCargoAdjust = p => post('screen_cargoadjust', p); //筛选
export const apicustCargoAdjust = p => get('cust_stock', p); //客户料帐信息
export const apicustcargoadjust = p => post('cargoadjust_import', p); //贷料调整导入
export const apiaccountadjust = p => post('accountadjust_import', p); //贷款调整导入
export const apiPrintCargoAdjust = p => get('cargoadjust_report', p); //打印
export const cargoadjustImport = p => post('cargoadjust_import', p); //导入


export const cargoadjustGetList = p => get('cargoadjust_get_list', p); //历史单据列表
export const daletesCargoadjust = p => get('daletes_cargoadjust', p); //批量删除
export const allCargoadjustCheck = p => get('all_cargoadjust_check', p); //批量审核
//现金银行调整
export const apiFirstMoney = p => get('bankadjust_first', p); //第一个
export const apiNextMoney = p => get('bankadjust_next', p); //下一个
export const apiPrevMoney = p => get('bankadjust_prev', p); //上一个
export const apiLastMoney = p => get('bankadjust_last', p); //最后一个
export const apiSearchMoney = p => get('bankadjust_list', p); //查询
export const apiaddMoney = p => post('add_bankadjust', p); //添加
export const apiModifyMoney = p => post('update_bankadjust', p); //修改
export const apiDelMoney = p => get('dalete_bankadjust', p); //删除
export const apiExportMoney = p => get('bankadjust_export', p); //导出
export const apiExportMoneyTem = p => get('bankadjust_template_export', p); //模板导出
export const apiAllSelectMoney = p => get('pull_bankadjust', p); //所有下拉框
export const apicheckMoney = p => get('bankadjust_check', p); //审核
export const apichooseMoney = p => post('screen_bankadjust', p); //筛选
export const apiMoneyAllCheck = p => get('all_bankadjust_check', p); //批量审核

export const bankadjustGetList = p => get('bankadjust_get_list', p); //历史单据列表
export const daletesBankadjust = p => get('daletes_bankadjust', p); //批量删除
export const allBankadjustCheck = p => get('all_bankadjust_check', p); //批量审核
// 客户利息
export const apiCustInterest_count = p => get('perform_interest_mysql', p, 60000); // 利息/仓息计算
export const apiCustInterest_list = p => get('interest_lst', p); // 利息/仓息计算

// export const apiCustInterest_query = p => get('get_custinterest_view', p, 60000); // 利息/仓息查询
export const apiCustInterest_delete = p => get('delete_interest', p); // 删除利息仓息
// export const apiCustInterest_notice = p => get('send_interest_notice', p); // 计算公告
export const apiCustInterest_pull = p => get('pull_interest', p); // 下拉
//品类归属设定
export const apisetListAsc = p => get('typeset_list', p); //列表
export const apiaddAsc = p => post('add_typeset', p); //添加
export const apimodifyAsc = p => post('update_typeset', p); //修改
export const apidelAsc = p => get('delete_typeset', p); //删除
export const apiSAsc = p => get('pull_typeset', p); //下拉列表
//柜台过货绑定
export const apisetListCounter = p => get('counter_list', p); //列表
export const apimodifyCounter = p => post('add_update_counter', p); //修改
export const apidelCounter = p => get('dalete_counter', p); //删除
export const apiSCounter = p => get('pull_counter', p); //下拉列表
// 利息方案
// --父类--
export const apiInterest_f_list = p => get('get_interset', p); // 列表
export const apiInterest_f_add = p => post('add_interset', p); // 添加
export const apiInterest_f_details = p => get('interset_details', p); // 详情
export const apiInterest_f_upload = p => post('update_interset', p); // 修改
export const apiInterest_f_delete = p => get('delete_interset', p); // 删除
// --子类--
export const apiInterest_s_list = p => get('get_interset_dtl', p); // 列表
export const apiInterest_s_add = p => post('add_interset_dtl', p); // 添加
export const apiInterest_s_details = p => get('interset_dtl_details', p); // 详情
export const apiInterest_s_upload = p => post('update_interset_dtl', p); // 修改
export const apiInterest_s_delete = p => get('delete_interset_dtl', p); // 删除
export const apiInterest_s_pull = p => get('pull_interset', p); // 利息方案数据下拉
export const apiInterest_s_copy = p => get('copy_interset', p); // 复制利息方案数据

// 新利息方案

// --------
//全局数据
export const staffParameter = p => get('staff_parameter', p); // 数量设置数据
//库存分析
export const analysePull = p => get('analyse_pull', p); // 筛选下拉
export const analyse = p => get('analyse', p); // 筛选
// 客户工费
export const custStyleLists = p => post('cust_style_lists', p); // 选择产品
export const custStylePull = p => get('cust_style_pull', p); // 筛选下拉
export const aCustWage = p => get('a_cust_wage', p); // //临时存储
export const custwageImport = p => post('custwage_import', p); // 导入
// 生产管理
export const yieldIndex = p => get('yield_index', p); // 列表数据
export const yieldPull = p => get('yield_pull', p); // 列表下拉
export const yieldDateils = p => get('yield_dateils', p); // 列表详情
export const yieldAdd = p => post('yield_add', p); // 添加
export const yieldSkill = p => get('yield_skill', p); // 工人卡号换
export const yieldIssue = p => get('yield_issue', p); //
export const yieldCheck = p => get('yield_check', p); // 列表审核
export const yieldDel = p => get('yield_del', p); // 列表删除
export const yield_losscasesApi = p => get('yield_losscases', p); // 生产损耗列表
export const yield_loss_pullApi = p => get('yield_loss_pull', p); // 生产损耗列表下拉
export const yield_loss_exportApi = p => get('yield_loss_export', p); // 生产损耗列表导出

export const yieldBoard = p => get('yield_board', p); // 看板秒
export const yieldBoard3 = p => get('yield_board3', p); // 看板五分钟
export const yieldBoard2 = p => get('yield_board2', p); // 看板
export const yieldWordList = p => get('yield_word_list', p); // 列表拖拽
export const yieldWordUpdate = p => get('yield_word_update', p); // 拖拽保存

// 损耗设置

export const RatedlossIndex = p => get('Ratedloss_index', p); // 列表详情
export const RatedlossDel = p => get('Ratedloss_del', p); // 删除
export const RatedlossPull = p => get('Ratedloss_pull', p); // 下拉
export const RatedlossAdd = p => get('Ratedloss_add', p); // 添加
export const RatedlossEdit = p => get('Ratedloss_edit', p); // 添加
export const RatedlossExport = p => get('Ratedloss_export', p); // 导出
export const RatedlossImports = p => get('Ratedloss_imports', p); // 导入
export const RatedlossExports = p => get('Ratedloss_exports', p); // 模板


// 仓库管理
export const storeIndex = p => get('store_index', p); // 列表
export const pullStore = p => get('pull_store', p); // 下拉store_add
export const storeAdd = p => post('store_add', p); // 添加
export const storeDel = p => get('store_del', p); // 删除
export const storeUp = p => post('store_up', p); // 删除

// 单号规则设置
export const oddIndex = p => get('odd_index', p); // 列表
export const oddUpdate = p => post('odd_update', p); // 列表



//检测发出
export const SendIndex = p => get('Send_index', p); // 列表
export const SendAdd = p => post('Send_add', p); // 添加
export const SendUpdate = p => post('Send_update', p); // 修改
export const SendDel = p => get('Send_del', p); // 删除
export const SendCheck = p => get('Send_check', p); // 审核
export const SendPull = p => get('Send_pull', p); // 下拉

//检测收回
export const GetIndex = p => get('Get_index', p); // 列表
export const GetAdd = p => post('Get_add', p); // 添加
export const GetUpdate = p => post('Get_update', p); // 修改
export const GetDel = p => get('Get_del', p); // 删除
export const GetCheck = p => get('Get_check', p); // 审核
export const GetPull = p => get('Get_pull', p); // 下拉
export const GetstoreNo = p => get('Get_send', p); // 下拉
// 样品检测
export const DetectionIndex = p => get('Detection_index', p); // 数据
export const DetectionPull = p => get('Detection_pull', p); // 下拉
export const DetectionAdd = p => post('Detection_add', p); // 添加
export const DetectionCheck = p => get('Detection_check', p); // 审核
export const DetectionBatch = p => get('Detection_batch', p); // 批号
export const DetectionBatchs = p => get('Detection_batchs', p); // 批号
export const DetectionDel = p => get('Detection_del', p); // 删除
export const DetectionUpdate = p => post('Detection_update', p); // 修改
export const DetectionDayin = p => get('Detection_dayin', p); // 删除

//客退入库/入库新接口

export const insjQuitIndex = p => get('insj_quit_index', p); // 入库数据
export const insjQuitDel = p => get('insj_quit_del', p); // 删除
export const insjQuitCheck = p => get('insj_quit_check', p); // 审核
export const insjQuitChecks = p => get('insj_quit_checks', p); // 批量审核
export const insjQuitReflex = p => post('insj_quit_reflex', p); // 结价折转
export const insjQuitSum = p => post('insj_quit_sum', p); // 合计
export const insjQuitAdd = p => post('insj_quit_add', p); // 添加
export const insjQuitUpdate = p => post('insj_quit_update', p); // 添加
export const insjQuitPull = p => get('insj_pull', p); // 下拉
export const insjQuitcustPull = p => get('insj_quit_pull', p); // 下拉
export const insjQuitScreen = p => get('insj_quit_screen', p); // 筛选
export const insjQuitSearch = p => get('insj_quit_search', p); // 筛选
// export const insjGetRandoms = p => get('insj_get_randoms', p); // 保存去重参数
export const insjGetBarcodeInfo = p => post('getBarcodes_insj', p); // 客退-获取条码信息
export const insjIsAllowUpdate = p => get('isAllowUpdate_insj', p); // 客退-是否允许修改

// 退场出库/出库新接口
export const salesjQuitIndex = p => get('salesj_quit_index', p); // 入库数据
export const salesjQuitDel = p => get('salesj_quit_del', p); // 删除
export const salesjQuitCheck = p => get('salesj_quit_check', p); // 审核
export const salesjQuitChecks = p => get('salesj_quit_checks', p); // 批量审核
export const salesjQuitReflex = p => post('salesj_quit_reflex', p); // 结价折转
export const salesjQuitSum = p => post('salesj_quit_sum', p); // 合计
export const salesjQuitAdd = p => post('salesj_quit_add', p); // 添加
export const salesjQuitUpdate = p => post('salesj_quit_update', p); // 添加
export const salesjQuitPull = p => get('salesj_pull', p); // 下拉
export const salesjQuitexitPull = p => get('salesj_quit_pull', p); // 下拉
export const salesjQuitScreen = p => get('salesj_quit_screen', p); // 筛选
export const salesjQuitSearch = p => get('salesj_quit_search', p); // 筛选
// export const salesjGetRandoms = p => get('salesj_get_randoms', p); // 保存去重参数
export const setScale = p => get('set_scale', p); // 获取电子秤重量
export const salesGetBarcodeInfo = p => post('getBarcodes_salesj', p); // 出库/退厂-获取条码信息
export const salesIsAllowUpdate = p => get('isAllowUpdate_salesj', p); // 出库/退厂-是否允许修改

// 条码组装管理
export const apiBarcodesAssemblyGetPull = p => get('pull_BarcodesAssembly', p); //下拉
export const apiBarcodesAssemblyGetData = p => post('search_BarcodesAssembly', p); //单据搜索
export const apiBarcodesAssemblyAddData = p => post('add_BarcodesAssembly', p); //新增
export const apiBarcodesAssemblyUpdateData = p => post('update_BarcodesAssembly', p); //修改
export const apiBarcodesAssemblyDelData = p => post('del_BarcodesAssembly', p); //删除
export const apiBarcodesAssemblyDelsData = p => post('dels_BarcodesAssembly', p); //批量删除
export const apiBarcodesAssemblycheck = p => post('check_BarcodesAssembly', p); //审核
export const apiBarcodesAssemblychecks = p => post('checks_BarcodesAssembly', p); //批量审核
export const apiBarcodesAssemblyIsAllowUp = p => post('isAllowUpdate_BarcodesAssembly', p); //是否允许修改
export const apiBarcodesAssemblyGetOrderList = p => post('index_BarcodesAssembly', p); //单据列表查询
export const apiBarcodesAssemblyPrintLab = p => post('printLabel_BarcodesAssembly', p); //标签打印
export const apiBarcodesAssemblyImpDtl = p => post('importdtl_BarcodesAssembly', p); // excel导入明细
export const apiBarcodesAssemblyTempExport = p => get('template_export_BarcodesAssembly', p); // 下载导入模板

// 条码拆卸管理
export const apiBarcodesDisassemblyGetPull = p => get('pull_BarcodesDisassembly', p); //下拉
export const apiBarcodesDisassemblyGetData = p => post('search_BarcodesDisassembly', p); //单据搜索
export const apiBarcodesDisassemblyAddData = p => post('add_BarcodesDisassembly', p); //新增
export const apiBarcodesDisassemblyUpdateData = p => post('update_BarcodesDisassembly', p); //修改
export const apiBarcodesDisassemblyDelData = p => post('del_BarcodesDisassembly', p); //删除
export const apiBarcodesDisassemblyDelsData = p => post('dels_BarcodesDisassembly', p); //批量删除
export const apiBarcodesDisassemblycheck = p => post('check_BarcodesDisassembly', p); //审核
export const apiBarcodesDisassemblychecks = p => post('checks_BarcodesDisassembly', p); //批量审核
export const apiBarcodesDisassemblyIsAllowUp = p => post('isAllowUpdate_BarcodesDisassembly', p); //是否允许修改
export const apiBarcodesDisassemblyGetOrderList = p => post('index_BarcodesDisassembly', p); //单据列表查询
export const apiBarcodesDisassemblyGetBarcodes = p => post('getBarcodes_BarcodesDisassembly', p); //获取条码

// 条码入库
export const apiBarcodeStorageGetPull = p => get('pull_barcodesin', p); //下拉
export const apiBarcodeStorageGetData = p => post('search_barcodesin', p); //单据搜索
export const apiBarcodeStorageAddData = p => post('add_barcodesin', p); //新增
export const apiBarcodeStorageUpdateData = p => post('update_barcodesin', p); //修改
export const apiBarcodeStorageDelData = p => post('del_barcodesin', p); //删除
export const apiBarcodeStorageDelsData = p => post('dels_barcodesin', p); //批量删除
export const apiBarcodeStoragecheck = p => post('check_barcodesin', p); //审核
export const apiBarcodeStoragechecks = p => post('checks_barcodesin', p); //批量审核
export const apiBarcodeStoragePriceAdMate = p => post('reflex_barcodesin', p); //结价结料
export const apiBarcodeStorageIsAllowUp = p => post('isAllowUpdate_barcodesin', p); //是否允许修改
export const apiBarcodeStoragePrint = p => get('report_barcodesin', p); //打印
export const apiBarcodeStorageGetOrderList = p => post('index_barcodesin', p); //单据列表查询
export const apiBarcodeStorageCheckBarCode = p => post('checkBarcode_barcodesin', p); //判断输入的条码号
export const apiBarcodeStoragePrintLab = p => post('printLabel_barcodesin', p); //标签打印
export const apiBarcodeStorageImpDtl = p => post('importdtl_barcodesin', p); // excel导入明细
export const apiBarcodeStorageTempExport = p => get('template_export_barcodesin', p); // 下载导入模板
// 条码销售出库
export const apiBarcodesoutGetPull = p => get('pull_barcodesout', p); //下拉
export const apiBarcodesoutGetData = p => post('search_barcodesout', p); //单据搜索
export const apiBarcodesoutAddData = p => post('add_barcodesout', p); //新增
export const apiBarcodesoutUpdateData = p => post('update_barcodesout', p); //修改
export const apiBarcodesoutDelData = p => post('del_barcodesout', p); //删除
export const apiBarcodesoutDelsData = p => post('dels_barcodesout', p); //批量删除
export const apiBarcodesoutcheck = p => post('check_barcodesout', p); //审核
export const apiBarcodesoutchecks = p => post('checks_barcodesout', p); //批量审核
export const apiBarcodesoutPriceAdMate = p => post('reflex_barcodesout', p); //结价结料
export const apiBarcodesoutIsAllowUp = p => post('isAllowUpdate_barcodesout', p); //是否允许修改
export const apiBarcodesoutProutt = p => post('report_barcodesout', p); //打印
export const apiBarcodesoutGetOrderList = p => post('index_barcodesout', p); //单据列表查询
export const apiBarcodesoutCheckBarCode = p => post('checkBarcode_barcodesout', p); //判断输入的条码号
export const apiBarcodesoutProuttLab = p => post('prouttLabel_barcodesout', p); //标签打印
export const apiBarcodesoutImpDtl = p => post('importdtl_barcodesout', p); // excel导入明细
export const apiBarcodesoutTempExport = p => get('template_export_barcodesout', p); // 下载导入模板
export const apiBarcodesoutgetBarcode = p => post('getBarcodes_barcodesout', p); // 条码输入
export const apiBarcodesoutgetBillno = p => get('getUsedBills_barcodesout', p); // 销售单号输入
export const apiBarcodesoutTempPrint = p => get('report_barcodesout', p); // 打印
export const apiBarcodesoutRfidPull = p => get("getRfidPull_barcodesout", p);//RFID下拉
export const apiBarcodesoutRfidData = p => post("getRfidData_barcodesout", p);//RFID确认
// 条码销售退货
export const apiBarcodesoutreturnGetPull = p => get('pull_barcodesoutreturn', p); //下拉
export const apiBarcodesoutreturnGetData = p => post('search_barcodesoutreturn', p); //单据搜索
export const apiBarcodesoutreturnAddData = p => post('add_barcodesoutreturn', p); //新增
export const apiBarcodesoutreturnUpdateData = p => post('update_barcodesoutreturn', p); //修改
export const apiBarcodesoutreturnDelData = p => post('del_barcodesoutreturn', p); //删除
export const apiBarcodesoutreturnDelsData = p => post('dels_barcodesoutreturn', p); //批量删除
export const apiBarcodesoutreturncheck = p => post('check_barcodesoutreturn', p); //审核
export const apiBarcodesoutreturnchecks = p => post('checks_barcodesoutreturn', p); //批量审核
export const apiBarcodesoutreturnPriceAdMate = p => post('reflex_barcodesoutreturn', p); //结价结料
export const apiBarcodesoutreturnIsAllowUp = p => post('isAllowUpdate_barcodesoutreturn', p); //是否允许修改
export const apiBarcodesoutreturnProutt = p => post('report_barcodesoutreturn', p); //打印
export const apiBarcodesoutreturnGetOrderList = p => post('index_barcodesoutreturn', p); //单据列表查询
export const apiBarcodesoutreturnCheckBarCode = p => post('checkBarcode_barcodesoutreturn', p); //判断输入的条码号
export const apiBarcodesoutreturnProuttLab = p => post('prouttLabel_barcodesoutreturn', p); //标签打印
export const apiBarcodesoutreturnImpDtl = p => post('importdtl_barcodesoutreturn', p); // excel导入明细
export const apiBarcodesoutreturnTempExport = p => get('template_export_barcodesoutreturn', p); // 下载导入模板
export const apiBarcodesoutreturngetBarcode = p => post('getBarcodes_barcodesoutreturn', p); // 条码输入
export const apiBarcodesoutreturngetBillno = p => get('getUsedBills_barcodesoutreturn', p); // 销售单号输入
export const apiBarcodesoutreturnTempPrint = p => get('report_barcodesoutreturn', p); // 打印
export const apiBarcodesoutreturnRfidPull = p => get("getRfidPull_barcodesoutreturn", p);//RFID下拉
export const apiBarcodesoutreturnRfidData = p => post("getRfidData_barcodesoutreturn", p);//RFID确认
// 条码采购退货
export const apiBarcodesinreturnGetPull = p => get('pull_barcodesinreturn', p); //下拉
export const apiBarcodesinreturnGetData = p => post('search_barcodesinreturn', p); //单据搜索
export const apiBarcodesinreturnAddData = p => post('add_barcodesinreturn', p); //新增
export const apiBarcodesinreturnUpdateData = p => post('update_barcodesinreturn', p); //修改
export const apiBarcodesinreturnDelData = p => post('del_barcodesinreturn', p); //删除
export const apiBarcodesinreturnDelsData = p => post('dels_barcodesinreturn', p); //批量删除
export const apiBarcodesinreturncheck = p => post('check_barcodesinreturn', p); //审核
export const apiBarcodesinreturnchecks = p => post('checks_barcodesinreturn', p); //批量审核
export const apiBarcodesinreturnPriceAdMate = p => post('reflex_barcodesinreturn', p); //结价结料
export const apiBarcodesinreturnIsAllowUp = p => post('isAllowUpdate_barcodesinreturn', p); //是否允许修改
export const apiBarcodesinreturnProutt = p => post('report_barcodesinreturn', p); //打印
export const apiBarcodesinreturnGetOrderList = p => post('index_barcodesinreturn', p); //单据列表查询
export const apiBarcodesinreturnCheckBarCode = p => post('checkBarcode_barcodesinreturn', p); //判断输入的条码号
export const apiBarcodesinreturnProuttLab = p => post('prouttLabel_barcodesinreturn', p); //标签打印
export const apiBarcodesinreturnImpDtl = p => post('importdtl_barcodesinreturn', p); // excel导入明细
export const apiBarcodesinreturnTempExport = p => get('template_export_barcodesinreturn', p); // 下载导入模板
export const apiBarcodesinreturngetBarcode = p => post('getBarcodes_barcodesinreturn', p); // 条码输入
export const apiBarcodesinreturngetBillno = p => get('getUsedBills_barcodesinreturn', p); // 销售单号输入
export const apiBarcodesinreturnTempPrint = p => get('report_barcodesinreturn', p); // 打印
export const apiBarcodesinreturnRfidPull = p => get("getRfidPull_barcodesinreturn", p);//RFID下拉
export const apiBarcodesinreturnRfidData = p => post("getRfidData_barcodesinreturn", p);//RFID确认
// 金包银入库
export const apiGoldsilverinGetPull = p => get('pull_goldsilverin', p); //下拉
export const apiGoldsilverinGetData = p => post('search_goldsilverin', p); //单据搜索
export const apiGoldsilverinAddData = p => post('add_goldsilverin', p); //新增
export const apiGoldsilverinUpdateData = p => post('update_goldsilverin', p); //修改
export const apiGoldsilverinDelData = p => post('del_goldsilverin', p); //删除
export const apiGoldsilverinDelsData = p => post('dels_goldsilverin', p); //批量删除
export const apiGoldsilverincheck = p => post('check_goldsilverin', p); //审核
export const apiGoldsilverinchecks = p => post('checks_goldsilverin', p); //批量审核
export const apiGoldsilverinPriceAdMate = p => post('reflex_goldsilverin', p); //结价结料
export const apiGoldsilverinIsAllowUp = p => post('isAllowUpdate_goldsilverin', p); //是否允许修改
export const apiGoldsilverinGetOrderList = p => post('index_goldsilverin', p); //单据列表查询
export const apiGoldsilverinCheckBarCode = p => post('checkBarcode_goldsilverin', p); //判断输入的条码号
export const apiGoldsilverinPrintLab = p => post('printLabel_goldsilverin', p); //标签打印
export const apiGoldsilverinImpDtl = p => post('importdtl_goldsilverin', p); // excel导入明细
export const apiGoldsilverinTempExport = p => get('template_export_goldsilverin', p); // 下载导入模板
export const apiGoldsilverinTempPrint = p => get('report_goldsilverin', p); // 打印

// 金包银销售出库
export const apiGoldsilveroutGetPull = p => get('pull_goldsilverout', p); //下拉
export const apiGoldsilveroutGetData = p => post('search_goldsilverout', p); //单据搜索
export const apiGoldsilveroutAddData = p => post('add_goldsilverout', p); //新增
export const apiGoldsilveroutUpdateData = p => post('update_goldsilverout', p); //修改
export const apiGoldsilveroutDelData = p => post('del_goldsilverout', p); //删除
export const apiGoldsilveroutDelsData = p => post('dels_goldsilverout', p); //批量删除
export const apiGoldsilveroutcheck = p => post('check_goldsilverout', p); //审核
export const apiGoldsilveroutchecks = p => post('checks_goldsilverout', p); //批量审核
export const apiGoldsilveroutPriceAdMate = p => post('reflex_goldsilverout', p); //结价结料
export const apiGoldsilveroutIsAllowUp = p => post('isAllowUpdate_goldsilverout', p); //是否允许修改
export const apiGoldsilveroutProutt = p => post('report_goldsilverout', p); //打印
export const apiGoldsilveroutGetOrderList = p => post('index_goldsilverout', p); //单据列表查询
export const apiGoldsilveroutCheckBarCode = p => post('checkBarcode_goldsilverout', p); //判断输入的条码号
export const apiGoldsilveroutProuttLab = p => post('prouttLabel_goldsilverout', p); //标签打印
export const apiGoldsilveroutImpDtl = p => post('importdtl_goldsilverout', p); // excel导入明细
export const apiGoldsilveroutTempExport = p => get('template_export_goldsilverout', p); // 下载导入模板
export const apiGoldsilveroutgetBarcode = p => post('getBarcodes_goldsilverout', p); // 条码输入
export const apiGoldsilveroutgetBillno = p => get('getUsedBills_goldsilverout', p); // 销售单号输入
export const apiGoldsilveroutTempPrint = p => get('report_goldsilverout', p); // 打印
// 金包银销售退货
export const apiGoldsilveroutreturnGetPull = p => get('pull_goldsilveroutreturn', p); //下拉
export const apiGoldsilveroutreturnGetData = p => post('search_goldsilveroutreturn', p); //单据搜索
export const apiGoldsilveroutreturnAddData = p => post('add_goldsilveroutreturn', p); //新增
export const apiGoldsilveroutreturnUpdateData = p => post('update_goldsilveroutreturn', p); //修改
export const apiGoldsilveroutreturnDelData = p => post('del_goldsilveroutreturn', p); //删除
export const apiGoldsilveroutreturnDelsData = p => post('dels_goldsilveroutreturn', p); //批量删除
export const apiGoldsilveroutreturncheck = p => post('check_goldsilveroutreturn', p); //审核
export const apiGoldsilveroutreturnchecks = p => post('checks_goldsilveroutreturn', p); //批量审核
export const apiGoldsilveroutreturnPriceAdMate = p => post('reflex_goldsilveroutreturn', p); //结价结料
export const apiGoldsilveroutreturnIsAllowUp = p => post('isAllowUpdate_goldsilveroutreturn', p); //是否允许修改
export const apiGoldsilveroutreturnGetOrderList = p => post('index_goldsilveroutreturn', p); //单据列表查询
export const apiGoldsilveroutreturnCheckBarCode = p => post('checkBarcode_goldsilveroutreturn', p); //判断输入的条码号
export const apiGoldsilveroutreturnProuttLab = p => post('prouttLabel_goldsilveroutreturn', p); //标签打印
export const apiGoldsilveroutreturnImpDtl = p => post('importdtl_goldsilveroutreturn', p); // excel导入明细
export const apiGoldsilveroutreturnTempExport = p => get('template_export_goldsilveroutreturn', p); // 下载导入模板
export const apiGoldsilveroutreturngetBarcode = p => post('getBarcodes_goldsilveroutreturn', p); // 条码输入
export const apiGoldsilveroutreturngetBillno = p => get('getUsedBills_goldsilveroutreturn', p); // 销售单号输入
export const apiGoldsilveroutreturnTempPrint = p => get('report_goldsilveroutreturn', p); // 打印
// 金包银采购退货
export const apiGoldsilverinreturnGetPull = p => get('pull_goldsilverinreturn', p); //下拉
export const apiGoldsilverinreturnGetData = p => post('search_goldsilverinreturn', p); //单据搜索
export const apiGoldsilverinreturnAddData = p => post('add_goldsilverinreturn', p); //新增
export const apiGoldsilverinreturnUpdateData = p => post('update_goldsilverinreturn', p); //修改
export const apiGoldsilverinreturnDelData = p => post('del_goldsilverinreturn', p); //删除
export const apiGoldsilverinreturnDelsData = p => post('dels_goldsilverinreturn', p); //批量删除
export const apiGoldsilverinreturncheck = p => post('check_goldsilverinreturn', p); //审核
export const apiGoldsilverinreturnchecks = p => post('checks_goldsilverinreturn', p); //批量审核
export const apiGoldsilverinreturnPriceAdMate = p => post('reflex_goldsilverinreturn', p); //结价结料
export const apiGoldsilverinreturnIsAllowUp = p => post('isAllowUpdate_goldsilverinreturn', p); //是否允许修改
export const apiGoldsilverinreturnProutt = p => post('report_goldsilverinreturn', p); //打印
export const apiGoldsilverinreturnGetOrderList = p => post('index_goldsilverinreturn', p); //单据列表查询
export const apiGoldsilverinreturnCheckBarCode = p => post('checkBarcode_goldsilverinreturn', p); //判断输入的条码号
export const apiGoldsilverinreturnProuttLab = p => post('prouttLabel_goldsilverinreturn', p); //标签打印
export const apiGoldsilverinreturnImpDtl = p => post('importdtl_goldsilverinreturn', p); // excel导入明细
export const apiGoldsilverinreturnTempExport = p => get('template_export_goldsilverinreturn', p); // 下载导入模板
export const apiGoldsilverinreturngetBarcode = p => post('getBarcodes_goldsilverinreturn', p); // 条码输入
export const apiGoldsilverinreturngetBillno = p => get('getUsedBills_goldsilverinreturn', p); // 销售单号输入
export const apiGoldsilverinreturnTempPrint = p => get('report_goldsilverinreturn', p); // 打印

// 金包银调拨结算
export const apiGoldsilvermovesettleGetPull = p => get('pull_goldsilvermovesettle', p); //下拉
export const apiGoldsilvermovesettleGetData = p => post('search_goldsilvermovesettle', p); //单据搜索
export const apiGoldsilvermovesettleAddData = p => post('add_goldsilvermovesettle', p); //新增
export const apiGoldsilvermovesettleUpdateData = p => post('update_goldsilvermovesettle', p); //修改
export const apiGoldsilvermovesettleDelData = p => post('del_goldsilvermovesettle', p); //删除
export const apiGoldsilvermovesettleDelsData = p => post('dels_goldsilvermovesettle', p); //批量删除
export const apiGoldsilvermovesettlecheck = p => post('check_goldsilvermovesettle', p); //审核
export const apiGoldsilvermovesettlechecks = p => post('checks_goldsilvermovesettle', p); //批量审核
export const apiGoldsilvermovesettlePriceAdMate = p => post('reflex_goldsilvermovesettle', p); //结价结料
export const apiGoldsilvermovesettleIsAllowUp = p => post('isAllowUpdate_goldsilvermovesettle', p); //是否允许修改
export const apiGoldsilvermovesettleProutt = p => post('report_goldsilvermovesettle', p); //打印
export const apiGoldsilvermovesettleGetOrderList = p => post('index_goldsilvermovesettle', p); //单据列表查询
export const apiGoldsilvermovesettleCheckBarCode = p => post('checkBarcode_goldsilvermovesettle', p); //判断输入的条码号
export const apiGoldsilvermovesettleProuttLab = p => post('prouttLabel_goldsilvermovesettle', p); //标签打印
export const apiGoldsilvermovesettleImpDtl = p => post('importdtl_goldsilvermovesettle', p); // excel导入明细
export const apiGoldsilvermovesettleTempExport = p => get('template_export_goldsilvermovesettle', p); // 下载导入模板
export const apiGoldsilvermovesettlegetBarcode = p => post('getBarcodes_goldsilvermovesettle', p); // 条码输入
export const apiGoldsilvermovesettlegetBillno = p => post('getUsedBills_goldsilvermovesettle', p); // 销售单号输入
export const apiGoldsilvermovesettleTempPrint = p => get('report_goldsilvermovesettle', p); // 打印
export const apiGoldsilvermovesettleIncountPull = p => get('incountpull_goldsilvermovesettle', p); // 选择门店获取柜台

// 条码库存盘点
export const apiGetInventoryCheckData = p => post("search_barcodestockcheck", p);//获取页面数据
export const apiGetInventorygetRfidPull = p => get("getRfidPull_barcodestockcheck", p);//RFID下拉
export const apiGetInventorygetRfidData = p => post("getRfidData_barcodestockcheck", p);//RFID确认
export const apiGetInventoryGetBillnos = p => get("getBillnos_barcodestockcheck", p);//弹窗里的单号获取
export const apiGetInventoryMergeBill = p => post("mergeBill_barcodestockcheck", p);//选择单号后获取合并后的盘点单数据
export const apiGetInventoryCheckBroadData = p => post("getBarcodes_barcodestockcheck", p);//获取条码信息
export const apiAddInventoryCheckData = p => post("add_barcodestockcheck", p);//新建数据
export const apiModifyInventoryCheckData = p => post("update_barcodestockcheck", p);//修改数据
export const apiCheckInventoryCheck = p => post("check_barcodestockcheck", p);//审核
export const apiCheckInventoryChecks = p => post("checks_barcodestockcheck", p);//批量审核
export const apiGetInventoryCheckPull = p => get("pull_barcodestockcheck", p);//获取下拉
// export const apiCanModifyInventoryCheckData = p =>post("isAllowUpdate_updatebarcodes",p);//是否允许修改和删除
export const apiDelInventoryCheckData = p => post("del_barcodestockcheck", p);//删除
export const apiDelInventoryCheckDatas = p => post("dels_barcodestockcheck", p);//批量删除
export const apiGetInventoryCheckHisTable = p => get("word_list_barcodestockcheck", p);//获取历史单据列表字段
export const apiUpInventoryCheckHisData = p => post("word_update_barcodestockcheck", p);//修改历史单据列表
export const apiGetInventoryCheckHisData = p => post("index_barcodestockcheck", p);//获取历史单据列表
export const apiCountInventoryCheckDiff = p => post("difference_barcodestockcheck", p);//计算差异
// 意见反馈
export const ideaAdd = p => post('idea_add', p); // 添加
export const ideaIndex = p => get('idea_index', p); // 反馈列表
export const ideaDel = p => get('idea_del', p); // 删除

//产品资料库
export const styleIndex = p => get('style_index', p); // 列表
export const stylePull = p => get('style_pull', p); // 下拉数据
export const styleCheck = p => get('style_check', p); // 审核
export const styleHandle = p => get('style_handle', p); // 批量操作
export const styleDateils = p => get('style_dateils', p); // 详情
export const styleAdd = p => post('style_add', p); // 添加
export const styleUpdate = p => post('style_update', p); // 保存
export const styleQuitIndex = p => get('style_quit_index', p); // 切换单据
export const styleDel = p => get('style_del', p); // 切换单据
export const styleExport = p => get('style_export', p); // 切换单据
export const styleLeadingIn = p => post("style_import", p);//产品资料导入
export const styleprintLabelStylesec = p => post('printLabel_stylesec', p); // 标签打印

// 工费方案
export const wagetypeIndex = p => get('wagetype_index', p); // 列表
export const wagetypeAdd = p => post('wagetype_add', p); // 添加
export const wagetypePull = p => get('wagetype_pull', p); // 添加
export const wagetypeDtlAdd = p => post('wagetype_dtl_add', p); // 添加
export const wagetypeDtlIndex = p => get('wagetype_dtl_index', p); // 添加
export const wagetypeDtlDel = p => get('wagetype_dtl_del', p); // 添加
export const wagetypeDel = p => get('wagetype_del', p); // 删除
export const wagetypeUpdate = p => post('wagetype_update', p); // 修改
export const wagetypeImport = p => post('wagetype_import', p); // 导入
export const wagetypeCheck = p => get('wagetype_check', p); // 审核
// 新利息方案
export const interestIndex = p => get('interest_index', p); // 列表
export const interestAdd = p => post('interest_add', p); // 添加
export const interestUpdate = p => post('interest_update', p); // 修改
export const interestDel = p => get('interest_del', p); // 删除
export const interestCheck = p => get('interest_check', p); // 审核

export const interestPull = p => get('interest_pull', p); // 下拉
export const interestDtlAdd = p => post('interest_dtl_add', p); // 详情添加
export const interestDtlIndex = p => get('interest_dtl_index', p); // 详情列表
export const interestDtlDel = p => get('interest_dtl_del', p); // 详情删除
export const interestImport = p => post('interest_import', p); // 导入
export const interestExport = p => post('interest_export', p); // 导出



//工费配置优先级
export const wagetypeEmployIndex = p => get('wagetype_employ_index', p); // 启用列表
export const wagetypeEmployUpdate = p => get('wagetype_employ_update', p); // 启用列表
export const wagetypeLaravelUpdate = p => get('wagetype_laravel_update', p); // 启用列表
export const salesjStyleWage = p => get('salesj_style_wage', p); // 产品获取工费
export const apiCustStyleWage = p => get('getCustStyleWage', p); // 选产品带出单价赋值








// 打印设置
export const printout_list = p => get('printout_list', p); // 列表
export const printout_pull = p => get('printout_pull', p); // 下拉
export const add_printout_dtl = p => post('add_printout_dtl', p); // 新增
export const printout_dtl_list = p => get('printout_dtl_list', p); // 模块列表
export const update_printout_dtl = p => post('update_printout_dtl', p); // 编辑
export const getPrinOut_dtl = p => get('getPrinOut_dtl', p); // 详情
export const delete_printout_dtl = p => get('delete_printout_dtl', p); // 删除
export const getPrinOut_pull = p => get('getPrinOut_pull', p); // 模块下拉
export const copy_printout_dtl = p => post('copy_printout_dtl', p); // 复制


// 打印初始化设置
export const apiPrintList = p => get('printout_list', p); //获取列表
export const apiPrintListright = p => get('getPrinOut_printout', p); //获取表格字段设置信息
export const apiUpdatePrint = p => post('update_printout', p); //更新表格字段设置信息


//出入库历史单据
export const insjIndex = p => get('insj_index', p); // 列表
export const insjQuitDels = p => get('insj_quit_dels', p); // 批量删除

export const salesjIndex = p => get('salesj_index', p); // 列表
export const salesjQuitDels = p => get('salesj_quit_dels', p); // 批量删除


//历史单据列表【排序接口
export const subscribeWordList = p => get('subscribe_word_list', p); // 订购历史列表
export const subscribeWordUpdate = p => get('subscribe_word_update', p); // 订购历史列表修改
export const insjWordList = p => get('insj_word_list', p); // 入库历史列表
export const insjWordUpdate = p => get('insj_word_update', p); // 入库历史列表修改
export const salesjWordList = p => get('salesj_word_list', p); // 出库历史列表
export const salesjWordUpdate = p => get('salesj_word_update', p); // 出库历史列表修改
export const balprcWordList = p => get('balprc_word_list', p); // 出库历史列表
export const balprcWordUpdate = p => get('balprc_word_update', p); // 出库历史列表修改


//客户进销存表
export const vendorInsale = p => get('vendor_insale', p); // 出库历史列表修改

// 会员管理
export const apiGetMemberList = p => post("index_MemberManage", p); // 获取会员管理列表
export const apiUpdateMemberStatus = p => post("upStatus_MemberManage", p); // 改变会员状态
export const apiUpdateMemberData = p => post("update_MemberManage", p); // 编辑会员数据
export const apiAddMemberData = p => post("add_MemberManage", p); // 新增会员数据
export const apiDeleteMemberData = p => get("delete_MemberManage", p); // 删除会员数据
export const apiMemberManagePull = p => get("pull_MemberManage", p); // 会员管理下拉
export const apiGetDataMemberManage = p => get("getData_MemberManage", p); // 获取会员数据
export const apiPrintMemberRenew = p => post("print_MemberRenewManage", p); // 打印


// 会员续费管理
export const apiGetMemberRenewList = p => post("index_MemberRenewManage", p); // 获取会员续费管理列表
export const apiPullMemberRenew = p => get("pull_MemberRenewManage", p); // 会员续费管理下拉
export const apiAddMemberRenew = p => post("add_MemberRenewManage", p); // 新增会员续费数据
export const apiUpdateMemberRenew = p => post("update_MemberRenewManage", p); // 编辑会员续费数据
export const apiDeleteMemberRenew = p => get("delete_MemberRenewManage", p); // 删除续费会员数据
export const apiCheckMemberRenew = p => get("check_MemberRenewManage", p); // 会员续费管理审核
export const apiCheckAllMemberRenew = p => post("checks_MemberRenewManage", p); // 会员续费批量审核


// 会员储值管理
export const apiGetMemberBalanceList = p => post("index_MemberBalanceManage", p); // 获取会员储值管理列表
export const apiPullMemberBalance = p => get("pull_MemberBalanceManage", p); // 会员储值管理下拉
export const apiAddMemberBalance = p => post("add_MemberBalanceManage", p); // 新增会员储值数据
export const apiUpdateMemberBalance = p => post("update_MemberBalanceManage", p); // 编辑会员储值数据
export const apiDeleteMemberBalance = p => get("delete_MemberBalanceManage", p); // 删除储值会员数据
export const apiCheckMemberBalance = p => get("check_MemberBalanceManage", p); // 会员储值管理审核
export const apiCheckAllMemberBalance = p => post("checks_MemberBalanceManage", p); // 会员储值批量审核
export const apiPrintMemberBalance = p => post("print_MemberBalanceManage", p); // 打印


// 会员标签管理
export const apiGetMemberTagsStatusList = p => post("index_MemberTagsManage", p); // 获取会员标签列表
export const apiUpdateMemberTagsStatus = p => post("upStatus_MemberTagsManage", p); // 改变会员标签状态
export const apiUpdateMemberTagsData = p => post("update_MemberTagsManage", p); // 编辑会员标签数据
export const apiAddMemberTagsData = p => post("add_MemberTagsManage", p); // 新增会员标签数据
export const apiDeleteMemberTagsData = p => get("delete_MemberTagsManage", p); // 删除会员标签数据
export const apiMemberTagsManagePull = p => get("pull_MemberTagsManage", p); // 会员标签管理下拉


// 会员储值方案管理
export const apiGetRechargePlanStatusList = p => post("index_RechargePlanManage", p); // 获取会员标签列表
export const apiUpdateRechargePlanStatus = p => post("upStatus_RechargePlanManage", p); // 改变会员标签状态
export const apiUpdateRechargePlanData = p => post("update_RechargePlanManage", p); // 编辑会员标签数据
export const apiAddRechargePlanData = p => post("add_RechargePlanManage", p); // 新增会员标签数据
export const apiDeleteRechargePlanData = p => get("delete_RechargePlanManage", p); // 删除会员标签数据
export const apiRechargePlanManagePull = p => get("pull_RechargePlanManage", p); // 会员标签管理下拉


// 会员储值流水表
export const apiMemberBalanceRpt = p => post('getData_MemberBalanceRpt', p); //列表信息
export const apiMemberBalanceRptPull = p => get('pull_MemberBalanceRpt', p); //下拉
export const apiMemberBalanceRptExport = (p) => {
  return axios({
    url: baseURL + 'getData_MemberBalanceRpt',
    method: 'post',
    data: p,
    responseType: 'arraybuffer'
  });
};



























